/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';

export function Circles({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='970' height='912' viewBox='0 0 970 912' {...props}>
      <g fill='none' fillRule='evenodd' stroke='#D8D8D8' strokeOpacity='.611' transform='translate(0 -572)'>
        <circle cx='742' cy='742' r='277.5' />
        <circle cx='742' cy='742' r='511.5' />
        <circle cx='742' cy='742' r='741.5' />
      </g>
    </svg>
  );
}

export function CirclesTwo({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1168' height='1168' viewBox='0 0 1168 1168' {...props}>
      <g fill='none' fillRule='evenodd' stroke='#D8D8D8' strokeOpacity='.611'>
        <circle cx='584' cy='584' r='218.5' />
        <circle cx='584' cy='584' r='402.5' />
        <circle cx='584' cy='584' r='583.5' />
      </g>
    </svg>
  );
}

export function ArrowDown({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H16V16H0z' />
        <path
          fill='#B5B5B5'
          fillRule='nonzero'
          d='M6 7.4L0.6 2 2 0.6 6 4.6 10 0.6 11.4 2z'
          transform='translate(2 4)'
        />
      </g>
    </svg>
  );
}

export function ArrowRight({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H16V16H0z' />
        <path
          fill='#FFF'
          d='M10.784 3.089l.07.057 5 5 .011.013c.012.012.023.025.033.039l-.044-.052c.026.027.05.056.069.087l.02.035.02.041.014.04c.005.015.009.03.012.046l.006.033.005.052v.04l-.005.052L16 8.5c0 .036-.004.071-.011.105l-.012.046-.015.04c-.005.014-.012.027-.019.04-.006.013-.013.025-.02.036l-.012.017-.013.018c-.01.014-.02.027-.033.04l-.011.012-5 5c-.196.195-.512.195-.708 0-.173-.174-.192-.443-.057-.638l.057-.07L14.293 9H.5C.224 9 0 8.776 0 8.5c0-.245.177-.45.41-.492L.5 8h13.793l-4.147-4.146c-.173-.174-.192-.443-.057-.638l.057-.07c.174-.173.443-.192.638-.057z'
        />
      </g>
    </svg>
  );
}
export function CashFlow({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H32V32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M25 16c3.795 0 7 1.602 7 4v8c0 2.398-3.205 4-7 4-3.707 0-6.85-1.529-6.995-3.834L18 28v-8l.005-.166C18.15 17.529 21.293 16 25 16zm0 12c-1.936 0-3.719-.417-5-1.144V28c0 .916 2.167 2 5 2 2.744 0 4.864-1.017 4.994-1.914L30 28v-1.144C28.72 27.583 26.937 28 25 28zM14 0c7.331 0 13.407 5.656 13.96 12.924.041.55-.372 1.031-.922 1.073-.55.042-1.031-.37-1.073-.921C25.492 6.848 20.283 2 14 2 7.372 2 2 7.372 2 14s5.372 12 12 12c.308 0 .616-.012.924-.035.551-.042 1.031.37 1.073.921.042.551-.37 1.031-.921 1.073-.359.027-.718.041-1.076.041-7.732 0-14-6.268-14-14S6.268 0 14 0zm16 22.856C28.72 23.583 26.937 24 25 24s-3.718-.417-5-1.144V24c0 .916 2.167 2 5 2 2.744 0 4.864-1.017 4.994-1.914L30 24zM25 18c-2.832 0-5 1.084-5 2 0 .916 2.168 2 5 2s5-1.084 5-2c0-.916-2.168-2-5-2zM14 7c.513 0 .936.386.993.883L15 8v6c0 .513-.386.936-.883.993L14 15H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 13h5V8c0-.513.386-.936.883-.993L14 7z'
        />
      </g>
    </svg>
  );
}
export function ChartLap({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H32V32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M31 23c.552 0 1 .448 1 1 0 2.761-2.239 5-5 5H5C2.332 29 .137 26.904.005 24.224l-.005-.2C-.013 23.464.438 23 1 23zm-1.171 2H2.17l.059.152c.43 1.035 1.425 1.775 2.594 1.843L5 27h22c1.302 0 2.41-.83 2.825-1.988L29.83 25zM26 3c1.598 0 2.904 1.249 2.995 2.824L29 6v14c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L27 20V6c0-.513-.386-.936-.883-.993L26 5H6c-.513 0-.936.386-.993.883L5 6v14c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L3 20V6c0-1.598 1.249-2.904 2.824-2.995L6 3h20zm-4 7h.019c.023 0 .047.002.07.004L22 10c.05 0 .1.004.149.011l.053.01c.02.004.04.008.06.014l.054.016.05.018c.02.008.039.016.057.025.022.01.044.021.065.033l.032.018c.021.013.042.027.062.042l.04.03c.061.048.117.104.165.166l-.08-.09c.036.035.068.073.097.112.018.024.034.049.05.074l.021.037c.012.02.022.041.032.063l.018.04c.01.026.02.052.029.08l.008.027c.007.024.013.048.018.073l.009.053.004.031.003.03.003.055L23 11v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L21 15v-1.586l-4.293 4.293c-.36.36-.928.388-1.32.083l-.094-.083L12 14.415l-2.293 2.292c-.36.36-.928.388-1.32.083l-.094-.083c-.36-.36-.388-.928-.083-1.32l.083-.094 3-3c.36-.36.928-.388 1.32-.083l.094.083L16 15.585 19.585 12H18c-.513 0-.936-.386-.993-.883L17 11c0-.513.386-.936.883-.993L18 10h4z'
        />
      </g>
    </svg>
  );
}
export function ChartPie({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M10 1c7.152 0 13 5.848 13 13 0 2.634-.822 5.241-2.275 7.365-.312.456-.935.572-1.391.26l-2.533-1.74C15.138 21.818 12.628 23 10 23c-4.952 0-9-4.048-9-9 0-4.615 3.515-8.444 8-8.945V2c0-.552.448-1 1-1zM3 14c0 3.848 3.152 7 7 7 1.965 0 3.854-.857 5.14-2.257l-5.706-3.919C9.162 14.638 9 14.33 9 14V7.072C5.622 7.56 3 10.492 3 14zm8-10.954v10.427l5.966 4.096c.065.026.128.059.189.099.068.045.129.098.182.156L19.6 19.38l.074-.131c.792-1.476 1.256-3.155 1.319-4.856L21 14c0-5.664-4.343-10.367-9.862-10.941L11 3.046z'
        />
      </g>
    </svg>
  );
}
export function CirclesBlock({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='108' height='172' viewBox='0 0 108 172' {...props}>
      <path
        fill='#F1F1F1'
        fillRule='evenodd'
        d='M6 160c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zM6 128c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zM6 96c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zM6 64c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zM6 32c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zM6 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm32 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6z'
      />
    </svg>
  );
}
export function CirclesDoc({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1606' height='710' viewBox='0 0 1606 710' {...props}>
      <g fill='none' fillRule='evenodd' stroke='#DEDEDE' transform='translate(-16)'>
        <circle cx='819' cy='-99' r='448.5' />
        <circle cx='819' cy='-99' r='268.5' />
        <circle cx='819' cy='-99' r='628.5' />
        <circle cx='819' cy='-99' r='808.5' />
      </g>
    </svg>
  );
}

export function CirclesDocSm({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 375 350' {...props}>
      <g fill='none' fillRule='evenodd' stroke='#DEDEDE' transform='translate(-186)'>
        <circle cx='375.5' cy='-21.5' r='206' />
        <circle cx='376' cy='-21' r='122.5' />
        <circle cx='376.5' cy='-20.5' r='289' />
        <circle cx='376.5' cy='-21.5' r='371' />
      </g>
    </svg>
  );
}

export function DetachedProperty({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12.213 1.023l.138.04 8 3c.517.195.78.771.585 1.288-.18.48-.69.74-1.176.62l-.111-.035L19 5.693V11h3c.513 0 .936.386.993.883L23 12v11c0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1v-5h-2v5c0 .513-.386.936-.883.993L10 24H2c-.552 0-1-.448-1-1V12c0-.552.448-1 1-1h3V5.693l-.649.243c-.48.18-1.011-.033-1.24-.478l-.047-.107c-.18-.48.033-1.011.478-1.24l.107-.047 8-3c.181-.068.377-.082.564-.041zM21 13H3v9h6v-5c0-.513.386-.936.883-.993L10 16h4c.552 0 1 .448 1 1v5h6v-9zM6 16c.513 0 .936.386.993.883L7 17v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L5 18v-1c0-.552.448-1 1-1zm12 0c.513 0 .936.386.993.883L19 17v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L17 18v-1c0-.552.448-1 1-1zM12 3.068L7 4.943V11h10V4.943l-5-1.875zM10 6c.513 0 .936.386.993.883L11 7v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L9 8V7c0-.552.448-1 1-1zm4 0c.513 0 .936.386.993.883L15 7v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L13 8V7c0-.552.448-1 1-1z'
        />
      </g>
    </svg>
  );
}
export function Fill205({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='708' height='682' viewBox='0 0 708 682' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='35.605%' y2='48.097%'>
          <stop offset='0%' stopColor='#F9F9F9' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M0 1122.552h679.076l-62.371 78.592-.351.456v136.081H92.569v-135.575H24.884v203.843l659.155.051v-351.767H29.797l62.421-79.604.351-.456V839.357h523.785v138.308h67.685V771.038h-62.772L708 690.978V371.221L117.102 78.884V0H0v1122.552zm412.986-425.355V368L584 453.094V778H324l88.986-80.803zm-315.634-.572l30.987-.454-4.405-457.657-.05-12.514L294 310.793V776H36l61.352-79.375z'
        opacity='.9'
      />
    </svg>
  );
}
export function GreenGroupEight({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='96' height='168' viewBox='0 0 96 168' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(24 96)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(24 96)'
          />
        </g>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(72 96)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(72 96)'
          />
        </g>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(0 48)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(0 48)'
          />
        </g>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(48 48)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(48 48)'
          />
        </g>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(72)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(72)'
          />
        </g>
        <g>
          <path d='M0 0H48V48H0z' transform='rotate(-180 54 90) translate(48 144)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M24 12c1.054 0 1.918.816 1.995 1.85L26 14v8h8c1.105 0 2 .895 2 2 0 1.054-.816 1.918-1.85 1.995L34 26h-8v8c0 1.105-.895 2-2 2-1.054 0-1.918-.816-1.995-1.85L22 34v-8h-8c-1.105 0-2-.895-2-2 0-1.054.816-1.918 1.85-1.995L14 22h8v-8c0-1.105.895-2 2-2z'
            transform='rotate(-180 54 90) translate(48 144)'
          />
        </g>
      </g>
    </svg>
  );
}
export function GroupNine({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='358' height='300' viewBox='0 0 358 300' {...props}>
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M357.927-278.8H20.362l30.474-39.983.171-.231v-69.23H306.92v68.972h33.07v-103.702L17.937-423v178.956H337.59l-30.498 40.498-.172.232-17.937 68.585-183.6-10.815-54.375-59.547h-33.07v105.119H0V106.858l289.08 154.405v38.72H358l-.073-578.783zM166.186-63.142l-18.004.23V95.402L74.266 57.485v-160.704h121.872l-29.952 40.077zm121.108.351l-.169.231v225.08l.024 6.373-73.872-39.886V-98.626l121.872-4.593-47.855 40.428z'
      />
    </svg>
  );
}
export function MedicalCenter({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M23 0c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1zm-1 2H2v20h20V2zm-8 3c.552 0 1 .448 1 1v3h3c.513 0 .936.386.993.883L19 10v4c0 .552-.448 1-1 1h-3v3c0 .513-.386.936-.883.993L14 19h-4c-.552 0-1-.448-1-1v-3H6c-.513 0-.936-.386-.993-.883L5 14v-4c0-.552.448-1 1-1h3V6c0-.513.386-.936.883-.993L10 5zm-1 2h-2v3c0 .513-.386.936-.883.993L10 11H7v2h3c.513 0 .936.386.993.883L11 14v3h2v-3c0-.513.386-.936.883-.993L14 13h3v-2h-3c-.513 0-.936-.386-.993-.883L13 10V7z'
        />
      </g>
    </svg>
  );
}
export function Shopping({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M20 0c1.57 0 2.876 1.22 2.994 2.814L23 3v20c0 .513-.386.936-.883.993L22 24H2c-.513 0-.936-.386-.993-.883L1 23V3l.005-.176C1.097 1.254 2.407 0 4 0zm1.001 5.828C20.688 5.939 20.351 6 20 6H4c-.35 0-.686-.06-1-.172V22h18zM17 9c.552 0 1 .448 1 1 0 3.352-2.648 6-6 6s-6-2.648-6-6c0-.552.448-1 1-1s1 .448 1 1c0 2.248 1.752 4 4 4s4-1.752 4-4c0-.552.448-1 1-1zm3-7H4c-.548 0-1 .452-1 .963l.003.112C3.04 3.59 3.48 4 4 4h16c.548 0 1-.452 1-.963l-.003-.112C20.96 2.41 20.52 2 20 2z'
        />
      </g>
    </svg>
  );
}
export function GardenStyle({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12.326 1.055l.225.083c.214.084.493.204.821.362.76.366 1.519.816 2.232 1.355.815.616 1.516 1.309 2.068 2.085C19.042 4.334 20.488 4 22 4c.552 0 1 .448 1 1v8c0 6.075-4.925 11-11 11S1 19.075 1 13V5c0-.552.448-1 1-1 1.5 0 2.936.329 4.298.926.556-.805 1.272-1.514 2.108-2.135.716-.532 1.477-.97 2.239-1.32l.37-.165c.288-.122.52-.207.68-.259.206-.065.427-.063.631.008zM21 6.062l-.27.038c-1.005.158-1.982.5-2.926 1-.008.008-.018.013-.028.018l-.039.017c-.804.433-1.584.98-2.336 1.624-.72.618-1.362 1.281-1.914 1.944-.205.245-.368.455-.487.616l-.168.236c-.396.593-1.268.593-1.664 0-.066-.1-.178-.254-.332-.452l-.323-.4c-.552-.663-1.193-1.326-1.914-1.944-.758-.65-1.545-1.2-2.357-1.635-.01-.001-.017-.006-.026-.01l-.032-.02c-.94-.497-1.913-.837-2.913-.994L3 6.062V13c0 4.882 3.887 8.856 8.735 8.996L12 22c4.97 0 9-4.03 9-9V6.062zm-9.012-2.994l-.348.148-.158.071c-.643.296-1.287.666-1.882 1.109-.602.447-1.117.942-1.526 1.483.628.4 1.237.856 1.827 1.362.81.695 1.529 1.438 2.148 2.181l-.027-.032L12 9.364l.269-.313c.435-.495.913-.986 1.433-1.459l.397-.351c.58-.498 1.179-.947 1.794-1.34-.403-.523-.908-1.007-1.495-1.45-.6-.454-1.247-.837-1.894-1.15l-.306-.142-.21-.091z'
        />
      </g>
    </svg>
  );
}
export function Hotel({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M23 0c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1zm-1 2H2v20h20V2zm-5 4c.513 0 .936.386.993.883L18 7v10c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L16 17v-4H8v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L6 17V7c0-.552.448-1 1-1 .513 0 .936.386.993.883L8 7v4h8V7c0-.552.448-1 1-1z'
        />
      </g>
    </svg>
  );
}
export function Motel({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M23 22c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L23 24H1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L1 22h22zM16 0c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L16 2h-3v2.04c6.08.497 10.843 5.48 10.996 11.654L24 16v3c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1v-3C0 9.684 4.82 4.545 11 4.04V2H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 0h8zm-4 6C6.452 6 2 10.452 2 16v2h20v-2c0-5.454-4.303-9.849-9.719-9.996zM8.832 9.745c.306.46.182 1.08-.277 1.387-1.296.864-2.213 2.332-2.466 4.016-.082.547-.591.923-1.137.84-.547-.081-.923-.59-.84-1.136.335-2.237 1.564-4.205 3.333-5.384.46-.306 1.08-.182 1.387.277z'
        />
      </g>
    </svg>
  );
}
export function Hospital({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M15 3c.513 0 .936.386.993.883L16 4v3h5c.513 0 .936.386.993.883L22 8v3.382l1.447.724c.301.15.504.44.545.77L24 13v4c0 .513-.386.936-.883.993L23 18h-1c0 1.657-1.343 3-3 3s-3-1.343-3-3h-5.126c-.445 1.726-2.01 3-3.874 3-1.864 0-3.43-1.274-3.874-3H1c-.513 0-.936-.386-.993-.883L0 17V4c0-.513.386-.936.883-.993L1 3h14zM7 15c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm12 2c-.309 0-.585.14-.768.36-.039.103-.095.197-.164.28-.044.111-.068.233-.068.36 0 .552.448 1 1 1s1-.448 1-1c0-.127-.024-.249-.067-.36-.07-.083-.126-.177-.166-.28-.182-.22-.458-.36-.767-.36zm1-8h-4v7h.764c.513-.573 1.242-.948 2.06-.995L19 15c.889 0 1.687.386 2.236 1H22v-2.382l-1.447-.724c-.301-.15-.504-.44-.545-.77L20 12V9zm-6-4H2v11h1.126c.444-1.725 2.01-3 3.874-3 1.864 0 3.43 1.275 3.874 3H14V5zM8 6c.513 0 .936.386.993.883L9 7v1h1c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L10 10H9v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L7 11v-1H6c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L6 8h1V7c0-.552.448-1 1-1z'
        />
      </g>
    </svg>
  );
}
export function Industrial({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M22.35 8.24C22.997 7.686 24 8.147 24 9v14c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h4c.379 0 .725.214.894.553L8.36 13.48 15.4 8.2c.63-.472 1.515-.065 1.594.69L17 9v3.825zM4.38 10H2v12h20V11.173l-5.35 4.586c-.62.532-1.564.134-1.644-.65L15 15v-4l-6.4 4.8c-.466.35-1.12.225-1.433-.246l-.061-.107L4.38 10zM12 18c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L12 20h-1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L11 18h1zm7 0c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L19 20h-1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L18 18h1zM8 0c3.378 0 6.374 1.851 7.517 4.618.272.659-.212 1.382-.924 1.382H1.407C.695 6 .211 5.277.483 4.618 1.626 1.851 4.622 0 8 0zm0 2c-1.88 0-3.578.73-4.685 1.888L3.212 4h9.575l-.102-.112C11.63 2.785 10.04 2.07 8.267 2.005z'
        />
      </g>
    </svg>
  );
}
export function Restaurant({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M17.613 17.21l.094.083 3 3c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-3-3c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083zm-11-15l.094.083 5 5c.36.36.388.928.083 1.32l-.083.094L10.415 10 12 11.585l8.293-8.292c.536-.536 1.45-.304 1.666.423.943 3.18.082 6.623-2.252 8.991-1.617 1.617-3.154 2.759-4.566 3.504-.883.465-1.55.695-1.956.772-.543.102-1.066-.255-1.168-.798-.095-.504.207-.99.685-1.14l.113-.028c.21-.04.688-.204 1.392-.576 1.233-.65 2.609-1.671 4.08-3.143 1.364-1.383 2.083-3.24 2.046-5.13l-.003-.084L4.707 21.707c-.36.36-.928.388-1.32.083l-.094-.083c-.36-.36-.388-.928-.083-1.32l.083-.094L10.585 13 9 11.415l-1.293 1.292c-.36.36-.928.388-1.32.083l-.094-.083-5-5c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083l.094.083L7 10.585 7.585 10 3.293 5.707c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083l.094.083L9 8.585 9.585 8 5.293 3.707c-.36-.36-.388-.928-.083-1.32l.083-.094c.36-.36.928-.388 1.32-.083z'
        />
      </g>
    </svg>
  );
}
export function Storage({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M11.629 1.072c.238-.096.504-.096.742 0l10 4c.38.151.629.52.629.928v17c0 .552-.448 1-1 1h-4.017l-11.966-.001L6 24H2c-.552 0-1-.448-1-1V6c0-.409.249-.777.629-.928zM12 3.077L3 6.676V22h2V10c0-.513.386-.936.883-.993L6 9h12c.552 0 1 .448 1 1v12h2V6.677l-9-3.6zm5 16.765H7v2.157L17 22v-2.158zM7 15.178v2.664h10v-2.664H7zM17 11H7v2.178h10V11z'
        />
      </g>
    </svg>
  );
}
export function CarWash({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          d='M17.279 8c.86 0 1.623.551 1.895 1.367l1.7 5.093 1.54 1.54c.374.376.585.884.586 1.414V23c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1v-1H6v1c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1v-5.586c.001-.53.212-1.038.586-1.414l1.535-1.54 1.7-5.093C5.094 8.55 5.859 7.999 6.721 8zm2.307 8H4.414L3 17.414V20h18v-2.586L19.586 16zM6 17c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm12 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-.721-7H6.721l-1.333 4h13.224l-1.333-4zM20 0l.127.128C20.568.578 22 2.12 22 3.125c0 1.105-.895 2-2 2s-2-.895-2-2C18 1.938 20 0 20 0zm-8 0l.127.128C12.568.578 14 2.12 14 3.125c-.008.517-.225 1.008-.602 1.362-.377.353-.882.539-1.398.513-.516.026-1.02-.16-1.398-.513-.377-.354-.594-.845-.602-1.362C10 1.938 12 0 12 0zM4 0l.127.128C4.568.578 6 2.12 6 3.125c-.008.517-.225 1.008-.602 1.362C5.02 4.84 4.516 5.026 4 5c-.516.026-1.02-.16-1.398-.513-.377-.354-.594-.845-.602-1.362C2 1.938 4 0 4 0z'
        />
      </g>
    </svg>
  );
}
export function Communities({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M2 11c1.847 0 4.072.626 5.352 1.879l.117.121H10c2.689 0 4.882 2.122 4.995 4.783L15 18c0 .513-.386.936-.883.993L14 19H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 17h4.829l-.004-.012c-.396-1.106-1.424-1.912-2.649-1.983L10 15H7c-.285 0-.555-.122-.744-.331l-.075-.095c-.631-.901-2.482-1.514-3.962-1.57L2 13v5.381l6.014 3.008c.628.313 1.343.397 2.021.239l.203-.055 10.489-3.228-.048-.128c-.291-.684-.94-1.151-1.68-1.21L18.837 17H17c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L17 15h1.838c1.653 0 3.127 1.015 3.725 2.542l.07.193.316.95c.164.494-.079 1.024-.544 1.23l-.11.04-11.47 3.53c-1.146.353-2.379.28-3.473-.199l-.232-.109-6.567-3.283c-.301-.15-.504-.44-.545-.77L0 19v-7c0-.513.386-.936.883-.993L1 11h1zm9 1c-.552 0-1-.448-1-1V5c0-.351.184-.677.486-.857l5-3c.316-.19.712-.19 1.028 0l5 3c.302.18.486.506.486.857v6c0 .552-.448 1-1 1zm5-8.834l-4 2.399V10h3V8c0-.552.448-1 1-1 .513 0 .936.386.993.883L17 8v2h3V5.566l-4-2.4z'
        />
      </g>
    </svg>
  );
}
export function Plant({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M17.076 1.003l.12.016 5 1c.542.109.893.636.785 1.177-.101.503-.562.842-1.061.8l-.116-.015-4.251-.851L16.118 6l1.435 2.869 4.25-.85c.504-.1.994.195 1.148.672l.03.113c.1.503-.195.993-.672 1.147l-.113.03-5 1c-.402.08-.808-.093-1.03-.428l-.06-.106L14.38 7H7.874c-.205.795-.648 1.494-1.248 2.017L10.618 17H18c.513 0 .936.386.993.883L19 18v4c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1h6.381L4.838 9.912c-.207.044-.42.072-.638.083L4 10c-2.21 0-4-1.79-4-4s1.79-4 4-4c1.864 0 3.43 1.275 3.874 3h6.507l1.725-3.447c.183-.367.569-.58.97-.55zM17 19H3v2h14v-2zM4 4c-1.105 0-2 .895-2 2s.895 2 2 2c.306 0 .595-.069.854-.191.013-.009.026-.016.04-.022l.028-.012C5.562 7.442 6 6.772 6 6c0-1.105-.895-2-2-2z'
        />
      </g>
    </svg>
  );
}
export function Banquet({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M8 24c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 22h3v-4.1c-2.208-.453-3.896-2.37-3.995-4.684L7 13V1c0-.552.448-1 1-1h8c.552 0 1 .448 1 1v12c0 2.396-1.707 4.42-3.999 4.896L13 22h3c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L16 24H8zm7-14H9v3c0 1.53 1.166 2.805 2.632 2.98l.17.015.173.005.174-.004C13.734 15.918 15 14.592 15 13v-3zm0-8H9v6h6V2z'
        />
      </g>
    </svg>
  );
}
export function Recreational({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12 2c6.564 0 12 2.47 12 6 0 .329-.047.648-.138.958l-1.365 8.634-.002.06c-.167 2.62-4.657 4.284-10.176 4.346L12 22c-5.664 0-10.324-1.679-10.495-4.348l-.003-.057L.138 8.958C.048 8.648 0 8.328 0 8l.001.05v-.01L0 8c0-3.53 5.436-6 12-6zm1 16h-2v1.98c.33.013.663.02 1 .02.337 0 .671-.007 1-.02V18zm8.386-6.183C19.176 13.183 15.775 14 12 14c-3.775 0-7.177-.817-9.386-2.183l.28 1.771c1.224 1.002 2.694 1.66 4.26 1.905.546.085.92.597.834 1.143-.085.545-.597.918-1.143.833-1.242-.194-2.435-.601-3.528-1.197l.17 1.072.013.156c0 .395.71 1.014 2.128 1.537.947.348 2.1.614 3.372.777V17c0-.513.386-.936.883-.993L10 16h4c.513 0 .936.386.993.883L15 17l.001 2.814c1.272-.163 2.424-.429 3.37-.777 1.34-.494 2.048-1.073 2.122-1.47l.02-.223.17-1.072c-1.093.596-2.286 1.003-3.528 1.197-.546.085-1.058-.288-1.143-.833-.085-.546.288-1.058.833-1.143 1.567-.245 3.037-.903 4.26-1.905zM12 4C6.414 4 2 6.006 2 8l.002-.058.088.555c.638 1.778 4.613 3.43 9.583 3.5L12 12c5.122 0 9.258-1.686 9.91-3.503L22 7.939C21.91 5.966 17.529 4 12 4zm6.24 3.064c.517.195.778.772.583 1.29-.195.516-.772.777-1.29.582-1.758-.664-3.629-.982-5.557-.936-1.88-.046-3.75.272-5.51.936-.517.195-1.094-.066-1.289-.583-.195-.517.066-1.094.583-1.289 2-.754 4.127-1.116 6.216-1.064 2.137-.052 4.264.31 6.264 1.064z'
        />
      </g>
    </svg>
  );
}
export function BankIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 70 70'
      {...props}
    >
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='18.82'
        y1='46.91'
        x2='51.18'
        y2='46.91'
      />
      <polyline
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        points='18.82 27.13 35 20.09 51.17 27.13'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='25.38'
        y1='28.92'
        x2='25.38'
        y2='42.92'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='44.62'
        y1='28.92'
        x2='44.62'
        y2='42.92'
      />
      <path
        fill='#fff'
        d='M35,30.92a2,2,0,0,1,2,1.95v8.05h-3.9V32.87a2,2,0,0,1,2-1.95m0-2h0a4,4,0,0,0-3.95,3.95V42.92H39V32.87a4,4,0,0,0-4-3.95Z'
      />
    </svg>
  );
}
export function EntertainmentFacilityIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 70 70'
      {...props}
    >
      <defs></defs>
      {/* <circle fill='#55dcac' cx='35' cy='35' r='35' /> */}
      <ellipse
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        cx='34.45'
        cy='31.93'
        rx='7.57'
        ry='9.27'
      />
      <path
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M26,40.23c-3.74,0-6.78-3.72-6.78-8.3s3-8.29,6.78-8.29'
      />
      <path
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M43.21,40.23c3.75,0,6.78-3.72,6.78-8.3s-3-8.29-6.78-8.29'
      />
      <path
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M34.45,43.72c.13,1.19.32,2.52-1.21,3.38a6.71,6.71,0,0,0-3.44,5.16'
      />
      <polygon points='32.62 44.09 34.54 41.84 36.28 44.09 32.62 44.09' />
    </svg>
  );
}
export function TechnologyIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 70 70'
      {...props}
    >
      {/* <circle fill='#55dcac' cx='35' cy='35' r='35' /> */}
      <rect
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x='22.49'
        y='35.89'
        width='25.02'
        height='9.49'
      />
      <rect
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x='22.49'
        y='26.45'
        width='25.02'
        height='9.49'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='42.73'
        y1='26.45'
        x2='42.73'
        y2='20.4'
      />
      <line fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' x1='25.54' y1='31.2' x2='28.22' y2='31.2' />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='25.54'
        y1='40.64'
        x2='28.22'
        y2='40.64'
      />
      <line fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' x1='29.54' y1='31.2' x2='32.22' y2='31.2' />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='29.54'
        y1='40.64'
        x2='32.22'
        y2='40.64'
      />
      <circle fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' cx='42.73' cy='18.34' r='2.05' />
    </svg>
  );
}
export function WarehouseIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 70 70'
      {...props}
    >
      {/* <circle fill='#55dcac' cx='35' cy='35' r='35' /> */}
      <polyline
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        points='23.52 31.15 23.52 44.34 19.12 44.34'
      />
      <line fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' x1='20' y1='32.32' x2='35' y2='25.58' />
      <polyline
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        points='46.48 31.15 46.48 44.34 50.88 44.34'
      />
      <polyline fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' points='50 32.32 35 25.58 20 32.32' />
      <rect
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x='28.5'
        y='37.92'
        width='6.5'
        height='6.5'
      />
      <rect
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x='31.75'
        y='31.15'
        width='6.5'
        height='6.5'
      />
      <rect fill='none' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' x='35' y='37.92' width='6.5' height='6.5' />
    </svg>
  );
}
export function AutoDealershipIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 70 70'
      {...props}
    >
      {/* <circle fill='#55dcac' cx='35' cy='35' r='35' /> */}
      <polyline
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        points='48.33 25.64 48.33 21.06 21.44 21.06 21.44 25.64'
      />
      <path
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M27.09,39.94H42.68a.56.56,0,0,1,.56.56v4.13a1,1,0,0,1-1,1H27.49a1,1,0,0,1-1-1V40.5A.56.56,0,0,1,27.09,39.94Z'
      />
      <path
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M39.29,35.43H30.47a2.83,2.83,0,0,0-2.68,2.4l-.43,2.11h15L42,37.83A2.84,2.84,0,0,0,39.29,35.43Z'
      />
      <polyline
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        points='52.09 48.94 48.33 48.94 48.33 29.95 21.44 29.95 21.44 48.94 17.25 48.94'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='28.53'
        y1='49.91'
        x2='28.53'
        y2='47.58'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='41.24'
        y1='49.91'
        x2='41.24'
        y2='47.58'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='28.52'
        y1='42.77'
        x2='31.19'
        y2='42.77'
      />
      <line
        fill='none'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2'
        x1='38.53'
        y1='42.77'
        x2='41.21'
        y2='42.77'
      />
    </svg>
  );
}
export function Letter({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M1 0H17V16H1z' transform='translate(-1)' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M16.04 7.667c.492 0 .898.386.954.883l.006.117v4c0 1.235-.921 2.246-2.087 2.328L14.76 15H3.24c-1.186 0-2.156-.96-2.235-2.174L1 12.666v-4c0-.552.43-1 .96-1 .492 0 .898.387.954.884l.006.117v4c0 .16.11.295.256.326L3.24 13h11.52c.155 0 .284-.114.313-.266l.007-.067v-4c0-.553.43-1 .96-1zM14.76 1C15.997 1 17 2.045 17 3.333v2c0 .366-.192.703-.5.878l-7.04 4c-.287.163-.633.163-.92 0l-7.04-4C1.192 6.036 1 5.7 1 5.333v-2C1 2.045 2.003 1 3.24 1zm0 2H3.24c-.177 0-.32.15-.32.333V4.74L9 8.194l6.08-3.455V3.333c0-.16-.11-.295-.256-.326L14.76 3z'
          transform='translate(-1)'
        />
      </g>
    </svg>
  );
}
export function LogoTop({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='121' height='28' viewBox='0 0 121 28' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g fill='#000'>
          <path
            d='M2.671 10.585c.778.273 1.773.411 2.957.411 1.629 0 2.898-.283 3.773-.842.866-.554 1.305-1.342 1.305-2.341 0-.886-.302-1.59-.898-2.094-.602-.51-1.564-.872-2.863-1.076l-2.217-.341c-.738-.11-1.257-.257-1.54-.44-.296-.189-.445-.486-.445-.883 0-.42.24-.745.716-.962.459-.211 1.128-.318 1.988-.318.761 0 1.364.115 1.794.34.422.223.745.586.961 1.08l2.217-.254c-.253-.971-.77-1.695-1.537-2.153-.79-.47-1.927-.71-3.375-.71-1.054 0-1.973.126-2.73.375C2.02.624 1.44.98 1.046 1.433c-.39.45-.588.99-.588 1.605 0 .914.334 1.633.993 2.137.667.51 1.74.867 3.189 1.063l1.81.251c.652.091 1.136.244 1.439.457.313.218.472.525.472.91 0 .48-.238.845-.706 1.088-.454.235-1.136.355-2.028.355-.994 0-1.752-.166-2.253-.492-.493-.321-.799-.83-.91-1.51h-2.3c.085.825.33 1.514.727 2.05.408.55 1.007.967 1.78 1.238M84.915 10.585c.778.273 1.773.411 2.957.411 1.628 0 2.897-.283 3.772-.842.867-.554 1.305-1.342 1.305-2.341 0-.886-.302-1.59-.897-2.094-.602-.51-1.565-.872-2.863-1.076l-2.217-.341c-.739-.11-1.257-.257-1.54-.44-.297-.189-.446-.486-.446-.883 0-.42.242-.745.717-.962.459-.211 1.128-.318 1.987-.318.762 0 1.365.115 1.795.34.422.223.745.586.961 1.08l2.216-.254c-.252-.971-.77-1.695-1.536-2.153-.791-.47-1.927-.71-3.375-.71-1.054 0-1.974.126-2.732.375-.754.247-1.335.603-1.728 1.056-.39.45-.588.99-.588 1.605 0 .914.334 1.633.993 2.137.666.51 1.74.867 3.189 1.063l1.81.251c.652.091 1.136.244 1.439.457.313.218.472.525.472.91 0 .48-.238.845-.706 1.088-.454.235-1.137.355-2.028.355-.994 0-1.753-.166-2.253-.492-.493-.321-.799-.83-.91-1.51h-2.301c.086.825.33 1.514.727 2.05.409.55 1.007.967 1.78 1.238M28.397 5.06c.353-.313.53-.746.53-1.296 0-.572-.175-1.008-.521-1.311-.348-.302-.818-.454-1.41-.454h-4.699v3.53h4.7c.58 0 1.048-.156 1.4-.469m1.552-4.059c.806.61 1.208 1.531 1.208 2.763 0 1.211-.4 2.101-1.2 2.673-.799.572-1.854.859-3.162.859h-4.498v3.465h-2.232V.086h6.73c1.297 0 2.35.305 3.154.915'
            transform='translate(27 16)'
          />
        </g>
        <path
          fill='#000'
          d='M78 25.113L78 27 67 27 67 16 77.983 16 77.983 17.887 69.315 17.887 69.315 20.811 76.416 20.811 75.344 22.222 69.315 22.222 69.315 25.113z'
        />
        <g fill='#000'>
          <path
            d='M71.475 25.288c-1.067.709-2.51 1.063-4.331 1.063-1.374 0-2.578-.21-3.61-.631-1.034-.421-1.839-1.047-2.413-1.878-.575-.83-.863-1.849-.863-3.057 0-1.207.288-2.231.863-3.074.574-.84 1.379-1.476 2.413-1.902 1.032-.425 2.236-.64 3.61-.64 1.82 0 3.267.366 4.339 1.097 1.072.73 1.681 1.75 1.826 3.058h-2.212c-.234-.71-.68-1.258-1.34-1.645-.66-.389-1.53-.582-2.613-.582-1.408 0-2.525.319-3.351.956-.827.636-1.24 1.548-1.24 2.732 0 1.186.413 2.1 1.24 2.742.826.642 1.943.963 3.35.963 1.073 0 1.938-.194 2.598-.581.659-.388 1.11-.936 1.356-1.645h2.212c-.156 1.308-.768 2.315-1.834 3.024M.104 9.995c1.581.028 1.803-.153 1.859-1.526V1.577H.216v-.461l3.66-.016 3.882 7.257L11.47 1.1h3.549v.45h-1.746v8.445h1.733v.448H9.656v-.448h1.76V2.207l-4.24 8.418h-.28l-4.45-8.262v6.106c0 .504.085.965.222 1.148.182.253.61.392 1.249.392.097 0 .207 0 .388-.014v.448h-4.2v-.448zM16.979 10.023c1.054-.014 1.29-.168 1.914-1.247L23.384.681l4.837 9.342h1.29v.42h-4.893v-.42h1.566l-1.414-2.87h-4.492l-.955 1.735-.014.056c-.153.35-.153.35-.153.462 0 .225.139.436.375.548.139.055.22.07.61.07h.776v.42H16.98v-.42zm7.556-3.319l-1.927-3.81-2.067 3.81h3.994zM31.458 9.995h1.816V1.55h-1.816V1.1h6.433c1.192 0 2.023.183 2.828.617 1.275.687 2.12 2.27 2.12 3.978 0 1.947-1.054 3.642-2.66 4.286-.832.322-1.691.462-2.87.462h-5.85v-.448zm5.546 0c.25 0 .887-.084 1.33-.168.93-.182 1.484-.518 1.955-1.218.444-.659.706-1.681.706-2.745 0-1.625-.54-3.027-1.44-3.726-.527-.392-1.33-.589-2.481-.589h-1.942v8.446h1.872z'
            transform='translate(27 1)'
          />
        </g>
        <path
          fill='#000'
          d='M72 10.569L73.98 10.569 73.98 2.432 72 2.432 72 2 78 2 78 2.432 76.02 2.432 76.02 10.569 78 10.569 78 11 72 11zM81.585 7.72h.375c.097.594.221 1.005.429 1.387.695 1.26 2.349 2.081 4.21 2.081 1.818 0 3.027-.779 3.027-1.925 0-.468-.209-.935-.57-1.218-.152-.128-.305-.212-.445-.27-.652-.197-1.625-.34-2.847-.381-1.568-.071-2.792-.44-3.485-1.077-.556-.51-.834-1.105-.834-1.784 0-.836.445-1.671 1.195-2.238.626-.482 1.667-.75 2.875-.75 1.292 0 2.25.254 3.569.963l.833-.695h.333v3.542h-.36c-.347-2.196-1.904-3.372-4.418-3.372-1.763 0-2.887.652-2.887 1.686 0 .311.124.623.32.85.61.679 1.374.92 3.304 1.005 1.721.085 2.945.453 3.625 1.09.584.567.889 1.246.889 1.983 0 .85-.417 1.643-1.153 2.195-.666.496-1.82.779-3.124.779-1.334 0-2.056-.185-3.64-.92l-.846.65-.375-.041V7.72zM102.994 2.762c1.111.964 1.75 2.352 1.75 3.782 0 2.875-2.375 5.055-5.5 5.055-3.098 0-5.36-2.138-5.36-5.07 0-2.818 2.444-5.055 5.513-5.055 1.417 0 2.596.425 3.597 1.288M95.77 6.416c0 1.544.307 2.648.96 3.456.68.85 1.624 1.331 2.639 1.331 2.166 0 3.471-1.784 3.471-4.773 0-1.458-.291-2.564-.875-3.327-.582-.751-1.527-1.19-2.61-1.19-2.236 0-3.585 1.685-3.585 4.503M107.515 10.82h.404c1.097 0 1.415-.34 1.415-1.473v-7.08h-1.79v-.454h3.916l7.11 6.997V3.357c-.014-.977-.264-1.132-1.791-1.09v-.454h3.583v.453c-.11-.013-.167-.013-.264-.013-.32 0-.694.113-.82.255-.194.198-.25.382-.25.905v8.27h-.36l-8.889-8.879v6.543c0 1.19.278 1.473 1.43 1.473h.418l.012.439h-4.124v-.439z'
        />
        <path fill='#0827C7' d='M16.441.6H.157v27.246h18.041V2.358c0-.968-.79-1.759-1.757-1.759' />
        <path
          fill='#FFF'
          d='M5.002 20.11h8.93l-.851 1.078-.005.007v1.867h-7.15v-1.86h-.924v2.797L14 24v-4.828H5.07l.851-1.093.005-.006v-1.85h7.15v1.898H14v-2.836h-.857L14 14.186v-4.144L5.923 6.045V5H5l.002 15.11zm4.952-5.917l.005-.007V9.085l3.117 1.543v4.657H9.102l.852-1.092zm-4.033 0l.005-.007V7.09l3.109 1.539v6.657H5.069l.852-1.092z'
        />
      </g>
    </svg>
  );
}
export function Mot({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='442' height='358' viewBox='0 0 442 358' {...props}>
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M441.91-356.89H25.14l37.624-49.385.211-.286v-85.51h315.959v85.192h40.83v-128.09L22.145-535v221.04H416.8l-37.653 50.02-.212.287-22.146 84.714-226.68-13.359-67.133-73.55H22.146v129.839H0V119.46l356.909 190.713V358H442l-.09-714.89zM205.888-90.565l-22.307.283V105L92 58.228V-140h151l-37.111 49.435zm148.819.485l-.21.285V188.13l.03 7.87L263 146.75V-134.33L414-140l-59.292 49.92z'
      />
    </svg>
  );
}
export function Nurse({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M11.725 1.038c.18-.05.37-.05.55 0l7 2c.429.123.725.516.725.962v12c0 4.452-3.548 8-8 8-4.368 0-7.866-3.415-7.996-7.749L4 16V4c0-.446.296-.839.725-.962zM18 13H6v3c0 3.348 2.652 6 6 6 3.272 0 5.88-2.533 5.996-5.773L18 16v-3zm-6-9.961L6 4.754V11h12V4.754l-6-1.715zM12 4c.513 0 .936.386.993.883L13 5v1h1c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L14 8h-1v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L11 9V8h-1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L10 6h1V5c0-.552.448-1 1-1z'
        />
      </g>
    </svg>
  );
}
export function OfficeBuilding({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M13.174 1.015l.113.027 10 3c.385.116.66.448.706.839L24 5v18c0 .513-.386.936-.883.993L23 24H1c-.513 0-.936-.386-.993-.883L0 23V13c0-.513.386-.936.883-.993L1 12h3V9c0-.513.386-.936.883-.993L5 8h10c.513 0 .936.386.993.883L16 9v13h6V5.743l-8-2.4V6c0 .513-.386.936-.883.993L13 7c-.513 0-.936-.386-.993-.883L12 6V2c0-.63.572-1.093 1.174-.985zM4 14L2 14v8h2v-8zM14 10H6v12h8V10zm-3 8c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L11 20H9c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L9 18h2zm8-10c.513 0 .936.386.993.883L20 9v10c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L18 19V9c0-.552.448-1 1-1zm-8 7c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L11 17H9c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L9 15h2zm0-3c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L11 14H9c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L9 12h2z'
        />
      </g>
    </svg>
  );
}
export function PathAudit({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H32V32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M10.5 0c3.512 0 6.373 2.785 6.496 6.267L17 6.5v19c0 2.486 2.014 4.5 4.5 4.5 2.415 0 4.385-1.9 4.495-4.288L26 25.5V13c0-.552.448-1 1-1 .513 0 .936.386.993.883L28 13v12.5c0 3.59-2.91 6.5-6.5 6.5-3.512 0-6.373-2.785-6.496-6.267L15 25.5v-19C15 4.014 12.986 2 10.5 2 8.085 2 6.115 3.9 6.005 6.288L6 6.5V19c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L4 19V6.5C4 2.91 6.91 0 10.5 0zM5 22c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm0 2c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM27 0c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm0 2c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z'
        />
      </g>
    </svg>
  );
}
export function Phone({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H16V16H0z' />
        <path
          fill='#FFF'
          d='M1.333 10.667v.666c0 1.838 1.496 3.334 3.334 3.334h.666V16h-.666C2.094 16 0 13.907 0 11.333v-.666h1.333zM5.171.848c.78-.78 2.049-.78 2.829 0L15.152 8c.78.78.78 2.049 0 2.829l-4.323 4.323c-.78.78-2.049.78-2.829 0L.848 8c-.78-.78-.78-2.049 0-2.829zm2.357 1.415c-.26-.261-.682-.261-.943 0L2.262 6.586c-.26.26-.26.682 0 .943l6.21 6.209c.26.26.681.26.942 0l4.323-4.323c.261-.26.261-.682 0-.943zM11.333 0C13.906 0 16 2.093 16 4.667v.666h-1.333v-.666c0-1.838-1.496-3.334-3.334-3.334h-.666V0h.666z'
        />
      </g>
    </svg>
  );
}
export function GreenGroupOne({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='133' height='231' viewBox='0 0 133 231' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(33 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(33 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(99 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(99 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(0 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(0 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(66 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(66 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(99)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(99)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='rotate(-180 74.5 123.5) translate(66 197)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='rotate(-180 74.5 123.5) translate(66 197)'
          />
        </g>
      </g>
    </svg>
  );
}
export function GreenGroupTwo({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='67' height='166' viewBox='0 0 67 166' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(33 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(33 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(0 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(0 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(33)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(33)'
          />
        </g>
      </g>
    </svg>
  );
}

export function PlusGroupOne({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 632 406' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M383.714 360.889c1.983 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.534-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm-90.285 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.28.01H297.19v15.038c0 2.076-1.684 3.759-3.761 3.759-1.984 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm-270.858 0c1.984 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01H26.333v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038H3.762c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.28-.01H18.81v-15.037c0-2.076 1.685-3.76 3.762-3.76zm180.572 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.748l-.282.01h-15.048v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.077 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zM158 270.667c1.983 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.077 0 3.761 1.683 3.761 3.76 0 1.981-1.534 3.605-3.48 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98H139.19c-2.077 0-3.761-1.683-3.761-3.759 0-1.982 1.534-3.605 3.48-3.749l.281-.01h15.048v-15.037c0-2.076 1.684-3.76 3.762-3.76zm90.286 0c1.983 0 3.608 1.533 3.751 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.481 3.748l-.28.01h-15.049v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98h-15.048c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm270.857 0c1.983 0 3.608 1.533 3.751 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.748l-.282.01h-15.048v15.038c0 2.076-1.683 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98h-15.048c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm-90.286 0c1.983 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.482 3.748l-.28.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.48-3.749l.282-.01h15.047v-15.037c0-2.076 1.684-3.76 3.762-3.76zm-90.286 0c1.984 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm45.143-90.223c1.983 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm-270.857 0c1.983 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.482 3.749l-.28.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.48-3.749l.282-.01h15.047v-15.037c0-2.076 1.684-3.76 3.762-3.76zm180.572 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.28.01H297.19v15.037c0 2.076-1.684 3.76-3.761 3.76-1.984 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm-90.286 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.48 3.749l-.282.01h-15.048v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm-180.572 0c1.984 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01H26.333v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001C1.684 206.76 0 205.076 0 203c0-1.982 1.535-3.605 3.481-3.749l.28-.01H18.81v-15.037c0-2.076 1.685-3.76 3.762-3.76zm225.715-90.222c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.481 3.749l-.28.01h-15.049v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.077 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.281-.01h15.047V93.98c0-2.076 1.685-3.759 3.763-3.759zm90.285 0c1.984 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.28-.01h15.048V93.98c0-2.076 1.685-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.482 3.749l-.28.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.76 0-1.981 1.534-3.605 3.48-3.748l.282-.01h15.047V93.98c0-2.076 1.684-3.759 3.762-3.759zm0-90.222c1.983 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.482 3.749l-.28.01-15.048-.001v15.038c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.682-3.762-3.758 0-1.982 1.534-3.606 3.48-3.75l.282-.01h15.047V3.759c0-2.076 1.684-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.749l-.282.01-15.048-.001v15.038c0 2.076-1.683 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28V26.314h-15.048c-2.077 0-3.762-1.682-3.762-3.758 0-1.982 1.535-3.606 3.482-3.75l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.749l-.28.01-15.049-.001v15.038c0 2.076-1.684 3.76-3.761 3.76-1.984 0-3.608-1.534-3.752-3.48l-.01-.28V26.314h-15.048c-2.078 0-3.762-1.682-3.762-3.758 0-1.982 1.535-3.606 3.481-3.75l.281-.01h15.047V3.759c0-2.076 1.685-3.759 3.763-3.759z'
      />
    </svg>
  );
}

export function PlusGroupTwo({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 407 316' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M383.714 270.889c1.983 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.534-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm-90.285 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.28.01H297.19v15.038c0 2.076-1.684 3.759-3.761 3.759-1.984 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm-90.286 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.748l-.282.01h-15.048v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.077 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm-180.572 0c1.984 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01H26.333v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038H3.762c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.28-.01H18.81v-15.037c0-2.076 1.685-3.76 3.762-3.76zM158 180.667c1.983 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.077 0 3.761 1.683 3.761 3.76 0 1.981-1.534 3.605-3.48 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V206.98H139.19c-2.077 0-3.761-1.683-3.761-3.759 0-1.982 1.534-3.605 3.48-3.749l.281-.01h15.048v-15.037c0-2.076 1.684-3.76 3.762-3.76zm90.286 0c1.983 0 3.608 1.533 3.751 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.481 3.748l-.28.01h-15.049v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V206.98h-15.048c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm90.285 0c1.984 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zM112.857 90.444c1.983 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.482 3.749l-.28.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.48-3.749l.282-.01h15.047V94.203c0-2.076 1.684-3.76 3.762-3.76zm90.286 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.48 3.749l-.282.01h-15.048v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm90.286 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.28.01H297.19v15.037c0 2.076-1.684 3.76-3.761 3.76-1.984 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047V94.203c0-2.076 1.685-3.76 3.763-3.76zm-270.858 0c1.984 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01H26.333v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001C1.684 116.76 0 115.076 0 113c0-1.982 1.535-3.605 3.481-3.749l.28-.01H18.81V94.203c0-2.076 1.685-3.76 3.762-3.76zM248.286.222c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.481 3.749l-.28.01h-15.049v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28V26.536l-15.048.001c-2.077 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.281-.01h15.047V3.98c0-2.076 1.685-3.759 3.763-3.759zm90.285 0c1.984 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.28-.01h15.048V3.98c0-2.076 1.685-3.759 3.762-3.759z'
      />
    </svg>
  );
}

export function PlusGroupThree({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='242' height='188' viewBox='0 0 242 188'>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M13.444 161.143c1.182 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.238 0 2.24 1.002 2.24 2.238 0 1.18-.913 2.147-2.073 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167-.001-8.953H2.241c-1.238 0-2.241-1.002-2.241-2.238 0-1.18.914-2.146 2.074-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.241-2.238zm107.556 0c1.181 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.241 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.963v-8.952c0-1.236 1.003-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.07l.007.168v8.952h8.962c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.073 2.232l-.168.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.778 0c1.18 0 2.149.913 2.234 2.07l.006.168v8.952h8.963c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.074 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.238 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.242-2.238zM94.11 107.429c1.181 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.006h-8.963v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.007-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.963v-8.952c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.07l.007.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.006h-8.964v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.778 0c1.18 0 2.149.913 2.234 2.07l.006.168v8.952h8.963c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.073 2.232l-.168.006h-8.963v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.238 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.242-2.238zM13.444 53.714c1.182 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.238 0 2.24 1.003 2.24 2.239 0 1.18-.913 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.006-.168-.001-8.953-8.962.001C1.003 69.381 0 68.379 0 67.143c0-1.18.914-2.147 2.074-2.232l.167-.006h8.962v-8.953c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.913 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.007-.168V69.38l-8.962.001c-1.238 0-2.241-1.002-2.241-2.238 0-1.18.914-2.147 2.073-2.232l.168-.006h8.962v-8.953c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.914 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.241 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168V69.38l-8.963.001c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.147 2.073-2.232l.167-.006h8.963v-8.953c0-1.236 1.003-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.071l.007.167v8.952h8.962c1.238 0 2.241 1.003 2.241 2.239 0 1.18-.914 2.146-2.073 2.232l-.168.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168V69.38l-8.963.001c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.913-2.147 2.073-2.232l.167-.006h8.962l.001-8.953c0-1.236 1.003-2.238 2.24-2.238zM147.888 0c1.182 0 2.15.913 2.235 2.071l.007.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.914 2.146-2.073 2.232l-.167.006-8.964-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168v-8.953h-8.963c-1.237 0-2.24-1.001-2.24-2.237 0-1.18.914-2.147 2.073-2.232l.167-.007h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.779 0c1.18 0 2.149.913 2.234 2.071l.006.167v8.952h8.963c1.238 0 2.241 1.003 2.241 2.239 0 1.18-.914 2.146-2.073 2.232l-.168.006-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.006-.168v-8.953h-8.963c-1.238 0-2.24-1.001-2.24-2.237 0-1.18.913-2.147 2.073-2.232l.167-.007h8.962V2.238c0-1.236 1.004-2.238 2.242-2.238z'
      />
    </svg>
  );
}
export function PlusGroupFour({ stroke = 'currentColor', ...props }) {
  return (
    <svg width='100%' height='100%' viewBox='0 0 194 150' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <title>E9F9978A-350C-4137-A9C7-75E513656C53</title>
      <desc>Created with sketchtool.</desc>
      <defs>
        <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id='linearGradient-1'>
          <stop stopColor='#FFFFFF' offset='0%'></stop>
          <stop stopColor='#F2F2F2' offset='100%'></stop>
        </linearGradient>
      </defs>
      <g id='about_cost_segregation' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          id='Tablet_madison_about_cs_vertical'
          transform='translate(-415.000000, -1473.000000)'
          fill='url(#linearGradient-1)'
        >
          <g id='on_average' transform='translate(40.000000, 992.000000)'>
            <g id='Group-5'>
              <g id='Other-/-big-icon' transform='translate(375.000000, 481.000000)'>
                <path
                  d='M10.7777778,128.571429 C11.7247509,128.571429 12.5005742,129.299891 12.5691471,130.223873 L12.5740741,130.357143 L12.574,137.499429 L19.7592593,137.5 C20.7513263,137.5 21.5555556,138.299492 21.5555556,139.285714 C21.5555556,140.227109 20.8227764,140.998362 19.893319,141.066531 L19.7592593,141.071429 L12.574,141.071429 L12.5740741,148.214286 C12.5740741,149.200508 11.7698448,150 10.7777778,150 C9.83080468,150 9.05498133,149.271538 8.98640849,148.347556 L8.98148148,148.214286 L8.981,141.071429 L1.7962963,141.071429 C0.804229246,141.071429 0,140.271937 0,139.285714 C0,138.34432 0.732779127,137.573067 1.6622366,137.504898 L1.7962963,137.5 L8.981,137.499429 L8.98148148,130.357143 C8.98148148,129.37092 9.78571073,128.571429 10.7777778,128.571429 Z M97,128.571429 C97.9469731,128.571429 98.7227965,129.299891 98.7913693,130.223873 L98.7962963,130.357143 L98.7962222,137.499429 L105.981481,137.5 C106.973549,137.5 107.777778,138.299492 107.777778,139.285714 C107.777778,140.227109 107.044999,140.998362 106.115541,141.066531 L105.981481,141.071429 L98.7962222,141.071429 L98.7962963,148.214286 C98.7962963,149.200508 97.9920671,150 97,150 C96.0530269,150 95.2772035,149.271538 95.2086307,148.347556 L95.2037037,148.214286 L95.2032222,141.071429 L88.0185185,141.071429 C87.0264515,141.071429 86.2222222,140.271937 86.2222222,139.285714 C86.2222222,138.34432 86.9550013,137.573067 87.8844588,137.504898 L88.0185185,137.5 L95.2032222,137.499429 L95.2037037,130.357143 C95.2037037,129.37092 96.0079329,128.571429 97,128.571429 Z M140.111111,128.571429 C141.058084,128.571429 141.833908,129.299891 141.90248,130.223873 L141.907407,130.357143 L141.907333,137.499429 L149.092593,137.5 C150.08466,137.5 150.888889,138.299492 150.888889,139.285714 C150.888889,140.227109 150.15611,140.998362 149.226652,141.066531 L149.092593,141.071429 L141.907333,141.071429 L141.907407,148.214286 C141.907407,149.200508 141.103178,150 140.111111,150 C139.164138,150 138.388315,149.271538 138.319742,148.347556 L138.314815,148.214286 L138.314333,141.071429 L131.12963,141.071429 C130.137563,141.071429 129.333333,140.271937 129.333333,139.285714 C129.333333,138.34432 130.066112,137.573067 130.99557,137.504898 L131.12963,137.5 L138.314333,137.499429 L138.314815,130.357143 C138.314815,129.37092 139.119044,128.571429 140.111111,128.571429 Z M183.222222,128.571429 C184.169195,128.571429 184.945019,129.299891 185.013592,130.223873 L185.018519,130.357143 L185.018444,137.499429 L192.203704,137.5 C193.195771,137.5 194,138.299492 194,139.285714 C194,140.227109 193.267221,140.998362 192.337763,141.066531 L192.203704,141.071429 L185.018444,141.071429 L185.018519,148.214286 C185.018519,149.200508 184.214289,150 183.222222,150 C182.275249,150 181.499426,149.271538 181.430853,148.347556 L181.425926,148.214286 L181.425444,141.071429 L174.240741,141.071429 C173.248674,141.071429 172.444444,140.271937 172.444444,139.285714 C172.444444,138.34432 173.177224,137.573067 174.106681,137.504898 L174.240741,137.5 L181.425444,137.499429 L181.425926,130.357143 C181.425926,129.37092 182.230155,128.571429 183.222222,128.571429 Z M75.4444444,85.7142857 C76.3914175,85.7142857 77.1672409,86.442748 77.2358137,87.36673 L77.2407407,87.5 L77.2406667,94.6422857 L84.4259259,94.6428571 C85.417993,94.6428571 86.2222222,95.4423487 86.2222222,96.4285714 C86.2222222,97.3699659 85.4894431,98.1412189 84.5599856,98.2093877 L84.4259259,98.2142857 L77.2406667,98.2142857 L77.2407407,105.357143 C77.2407407,106.343366 76.4365115,107.142857 75.4444444,107.142857 C74.4974714,107.142857 73.721648,106.414395 73.6530752,105.490413 L73.6481481,105.357143 L73.6476667,98.2142857 L66.462963,98.2142857 C65.4708959,98.2142857 64.6666667,97.4147942 64.6666667,96.4285714 C64.6666667,95.487177 65.3994458,94.715924 66.3289033,94.6477551 L66.462963,94.6428571 L73.6476667,94.6422857 L73.6481481,87.5 C73.6481481,86.5137772 74.4523774,85.7142857 75.4444444,85.7142857 Z M118.555556,85.7142857 C119.502529,85.7142857 120.278352,86.442748 120.346925,87.36673 L120.351852,87.5 L120.351778,94.6422857 L127.537037,94.6428571 C128.529104,94.6428571 129.333333,95.4423487 129.333333,96.4285714 C129.333333,97.3699659 128.600554,98.1412189 127.671097,98.2093877 L127.537037,98.2142857 L120.351778,98.2142857 L120.351852,105.357143 C120.351852,106.343366 119.547623,107.142857 118.555556,107.142857 C117.608582,107.142857 116.832759,106.414395 116.764186,105.490413 L116.759259,105.357143 L116.758778,98.2142857 L109.574074,98.2142857 C108.582007,98.2142857 107.777778,97.4147942 107.777778,96.4285714 C107.777778,95.487177 108.510557,94.715924 109.440014,94.6477551 L109.574074,94.6428571 L116.758778,94.6422857 L116.759259,87.5 C116.759259,86.5137772 117.563489,85.7142857 118.555556,85.7142857 Z M161.666667,85.7142857 C162.61364,85.7142857 163.389463,86.442748 163.458036,87.36673 L163.462963,87.5 L163.462889,94.6422857 L170.648148,94.6428571 C171.640215,94.6428571 172.444444,95.4423487 172.444444,96.4285714 C172.444444,97.3699659 171.711665,98.1412189 170.782208,98.2093877 L170.648148,98.2142857 L163.462889,98.2142857 L163.462963,105.357143 C163.462963,106.343366 162.658734,107.142857 161.666667,107.142857 C160.719694,107.142857 159.94387,106.414395 159.875297,105.490413 L159.87037,105.357143 L159.869889,98.2142857 L152.685185,98.2142857 C151.693118,98.2142857 150.888889,97.4147942 150.888889,96.4285714 C150.888889,95.487177 151.621668,94.715924 152.551125,94.6477551 L152.685185,94.6428571 L159.869889,94.6422857 L159.87037,87.5 C159.87037,86.5137772 160.6746,85.7142857 161.666667,85.7142857 Z M10.7777778,42.8571429 C11.7247509,42.8571429 12.5005742,43.5856052 12.5691471,44.5095872 L12.5740741,44.6428571 L12.574,51.7851429 L19.7592593,51.7857143 C20.7513263,51.7857143 21.5555556,52.5852058 21.5555556,53.5714286 C21.5555556,54.512823 20.8227764,55.284076 19.893319,55.3522449 L19.7592593,55.3571429 L12.574,55.3571429 L12.5740741,62.5 C12.5740741,63.4862228 11.7698448,64.2857143 10.7777778,64.2857143 C9.83080468,64.2857143 9.05498133,63.557252 8.98640849,62.63327 L8.98148148,62.5 L8.981,55.3571429 L1.7962963,55.3571429 C0.804229246,55.3571429 0,54.5576513 0,53.5714286 C0,52.6300341 0.732779127,51.8587811 1.6622366,51.7906123 L1.7962963,51.7857143 L8.981,51.7851429 L8.98148148,44.6428571 C8.98148148,43.6566344 9.78571073,42.8571429 10.7777778,42.8571429 Z M53.8888889,42.8571429 C54.835862,42.8571429 55.6116853,43.5856052 55.6802582,44.5095872 L55.6851852,44.6428571 L55.6851111,51.7851429 L62.8703704,51.7857143 C63.8624374,51.7857143 64.6666667,52.5852058 64.6666667,53.5714286 C64.6666667,54.512823 63.9338875,55.284076 63.0044301,55.3522449 L62.8703704,55.3571429 L55.6851111,55.3571429 L55.6851852,62.5 C55.6851852,63.4862228 54.8809559,64.2857143 53.8888889,64.2857143 C52.9419158,64.2857143 52.1660924,63.557252 52.0975196,62.63327 L52.0925926,62.5 L52.0921111,55.3571429 L44.9074074,55.3571429 C43.9153404,55.3571429 43.1111111,54.5576513 43.1111111,53.5714286 C43.1111111,52.6300341 43.8438902,51.8587811 44.7733477,51.7906123 L44.9074074,51.7857143 L52.0921111,51.7851429 L52.0925926,44.6428571 C52.0925926,43.6566344 52.8968218,42.8571429 53.8888889,42.8571429 Z M97,42.8571429 C97.9469731,42.8571429 98.7227965,43.5856052 98.7913693,44.5095872 L98.7962963,44.6428571 L98.7962222,51.7851429 L105.981481,51.7857143 C106.973549,51.7857143 107.777778,52.5852058 107.777778,53.5714286 C107.777778,54.512823 107.044999,55.284076 106.115541,55.3522449 L105.981481,55.3571429 L98.7962222,55.3571429 L98.7962963,62.5 C98.7962963,63.4862228 97.9920671,64.2857143 97,64.2857143 C96.0530269,64.2857143 95.2772035,63.557252 95.2086307,62.63327 L95.2037037,62.5 L95.2032222,55.3571429 L88.0185185,55.3571429 C87.0264515,55.3571429 86.2222222,54.5576513 86.2222222,53.5714286 C86.2222222,52.6300341 86.9550013,51.8587811 87.8844588,51.7906123 L88.0185185,51.7857143 L95.2032222,51.7851429 L95.2037037,44.6428571 C95.2037037,43.6566344 96.0079329,42.8571429 97,42.8571429 Z M140.111111,42.8571429 C141.058084,42.8571429 141.833908,43.5856052 141.90248,44.5095872 L141.907407,44.6428571 L141.907333,51.7851429 L149.092593,51.7857143 C150.08466,51.7857143 150.888889,52.5852058 150.888889,53.5714286 C150.888889,54.512823 150.15611,55.284076 149.226652,55.3522449 L149.092593,55.3571429 L141.907333,55.3571429 L141.907407,62.5 C141.907407,63.4862228 141.103178,64.2857143 140.111111,64.2857143 C139.164138,64.2857143 138.388315,63.557252 138.319742,62.63327 L138.314815,62.5 L138.314333,55.3571429 L131.12963,55.3571429 C130.137563,55.3571429 129.333333,54.5576513 129.333333,53.5714286 C129.333333,52.6300341 130.066112,51.8587811 130.99557,51.7906123 L131.12963,51.7857143 L138.314333,51.7851429 L138.314815,44.6428571 C138.314815,43.6566344 139.119044,42.8571429 140.111111,42.8571429 Z M118.555556,0 C119.502529,0 120.278352,0.728462313 120.346925,1.65244433 L120.351852,1.78571429 L120.351778,8.928 L127.537037,8.92857143 C128.529104,8.92857143 129.333333,9.72806295 129.333333,10.7142857 C129.333333,11.6556802 128.600554,12.4269331 127.671097,12.495102 L127.537037,12.5 L120.351778,12.5 L120.351852,19.6428571 C120.351852,20.6290799 119.547623,21.4285714 118.555556,21.4285714 C117.608582,21.4285714 116.832759,20.7001091 116.764186,19.7761271 L116.759259,19.6428571 L116.758778,12.5 L109.574074,12.5 C108.582007,12.5 107.777778,11.7005085 107.777778,10.7142857 C107.777778,9.77289125 108.510557,9.00163828 109.440014,8.93346941 L109.574074,8.92857143 L116.758778,8.928 L116.759259,1.78571429 C116.759259,0.799491518 117.563489,0 118.555556,0 Z M161.666667,0 C162.61364,0 163.389463,0.728462313 163.458036,1.65244433 L163.462963,1.78571429 L163.462889,8.928 L170.648148,8.92857143 C171.640215,8.92857143 172.444444,9.72806295 172.444444,10.7142857 C172.444444,11.6556802 171.711665,12.4269331 170.782208,12.495102 L170.648148,12.5 L163.462889,12.5 L163.462963,19.6428571 C163.462963,20.6290799 162.658734,21.4285714 161.666667,21.4285714 C160.719694,21.4285714 159.94387,20.7001091 159.875297,19.7761271 L159.87037,19.6428571 L159.869889,12.5 L152.685185,12.5 C151.693118,12.5 150.888889,11.7005085 150.888889,10.7142857 C150.888889,9.77289125 151.621668,9.00163828 152.551125,8.93346941 L152.685185,8.92857143 L159.869889,8.928 L159.87037,1.78571429 C159.87037,0.799491518 160.6746,0 161.666667,0 Z'
                  id='Combined-Shape'
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function PlusGroupFive({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='312' height='243' viewBox='0 0 312 243' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fill-rule='evenodd'
        d='M17.333 208.286c1.523 0 2.771 1.18 2.881 2.677l.008.216v11.57l11.556.001c1.595 0 2.889 1.295 2.889 2.893 0 1.525-1.179 2.774-2.674 2.885l-.215.008H20.222v11.571c0 1.598-1.293 2.893-2.889 2.893-1.523 0-2.77-1.18-2.88-2.677l-.009-.216v-11.571H2.889c-1.596 0-2.889-1.295-2.889-2.893 0-1.525 1.178-2.775 2.673-2.885l.216-.008h11.555v-11.571c0-1.598 1.294-2.893 2.89-2.893zm138.667 0c1.523 0 2.77 1.18 2.881 2.677l.008.216v11.57l11.555.001c1.596 0 2.89 1.295 2.89 2.893 0 1.525-1.18 2.774-2.674 2.885l-.216.008H158.89v11.571c0 1.598-1.294 2.893-2.889 2.893-1.523 0-2.77-1.18-2.881-2.677l-.008-.216v-11.571h-11.555c-1.596 0-2.89-1.295-2.89-2.893 0-1.525 1.18-2.775 2.674-2.885l.216-.008h11.555v-11.571c0-1.598 1.294-2.893 2.889-2.893zm69.333 0c1.523 0 2.771 1.18 2.881 2.677l.008.216v11.57l11.556.001c1.595 0 2.889 1.295 2.889 2.893 0 1.525-1.179 2.774-2.674 2.885l-.215.008h-11.556v11.571c0 1.598-1.293 2.893-2.889 2.893-1.523 0-2.77-1.18-2.88-2.677l-.009-.216v-11.571h-11.555c-1.596 0-2.889-1.295-2.889-2.893 0-1.525 1.178-2.775 2.673-2.885l.216-.008h11.555v-11.571c0-1.598 1.294-2.893 2.89-2.893zm69.334 0c1.523 0 2.77 1.18 2.88 2.677l.009.216v11.57l11.555.001c1.596 0 2.889 1.295 2.889 2.893 0 1.525-1.178 2.774-2.673 2.885l-.216.008h-11.556v11.571c0 1.598-1.293 2.893-2.888 2.893-1.523 0-2.771-1.18-2.881-2.677l-.008-.216v-11.571h-11.556c-1.595 0-2.889-1.295-2.889-2.893 0-1.525 1.179-2.775 2.674-2.885l.215-.008h11.555v-11.571c0-1.598 1.294-2.893 2.89-2.893zm-173.334-69.429c1.523 0 2.771 1.18 2.881 2.677l.008.216v11.571h11.556c1.595 0 2.889 1.296 2.889 2.893 0 1.525-1.179 2.775-2.674 2.885l-.215.008h-11.556v11.572c0 1.597-1.293 2.892-2.889 2.892-1.523 0-2.77-1.18-2.88-2.677l-.009-.215v-11.572h-11.555c-1.596 0-2.889-1.295-2.889-2.893 0-1.525 1.178-2.774 2.673-2.885l.216-.008h11.555V141.75c0-1.598 1.294-2.893 2.89-2.893zm69.334 0c1.523 0 2.77 1.18 2.88 2.677l.009.216v11.571h11.555c1.596 0 2.889 1.296 2.889 2.893 0 1.525-1.178 2.775-2.673 2.885l-.216.008h-11.556v11.572c0 1.597-1.293 2.892-2.888 2.892-1.523 0-2.771-1.18-2.881-2.677l-.008-.215v-11.572h-11.556c-1.595 0-2.889-1.295-2.889-2.893 0-1.525 1.179-2.774 2.674-2.885l.215-.008h11.555V141.75c0-1.598 1.294-2.893 2.89-2.893zm69.333 0c1.523 0 2.77 1.18 2.881 2.677l.008.216v11.571h11.555c1.596 0 2.89 1.296 2.89 2.893 0 1.525-1.18 2.775-2.674 2.885l-.216.008H262.89v11.572c0 1.597-1.294 2.892-2.889 2.892-1.523 0-2.77-1.18-2.881-2.677l-.008-.215v-11.572h-11.555c-1.596 0-2.89-1.295-2.89-2.893 0-1.525 1.18-2.774 2.674-2.885l.216-.008h11.555V141.75c0-1.598 1.294-2.893 2.889-2.893zM17.333 69.43c1.523 0 2.771 1.18 2.881 2.677l.008.215v11.572h11.556c1.595 0 2.889 1.295 2.889 2.893 0 1.525-1.179 2.774-2.674 2.885l-.215.008H20.222v11.571c0 1.598-1.293 2.893-2.889 2.893-1.523 0-2.77-1.18-2.88-2.677l-.009-.216V89.679H2.889C1.293 89.679 0 88.383 0 86.786 0 85.26 1.178 84.01 2.673 83.9l.216-.008h11.555V72.32c0-1.597 1.294-2.892 2.89-2.892zm69.334 0c1.523 0 2.77 1.18 2.88 2.677l.009.215v11.572h11.555c1.596 0 2.889 1.295 2.889 2.893 0 1.525-1.178 2.774-2.673 2.885l-.216.008H89.555v11.571c0 1.598-1.293 2.893-2.888 2.893-1.523 0-2.771-1.18-2.881-2.677l-.008-.216V89.679H72.221c-1.595 0-2.889-1.296-2.889-2.893 0-1.525 1.179-2.775 2.674-2.885l.215-.008h11.555V72.32c0-1.597 1.294-2.892 2.89-2.892zm69.333 0c1.523 0 2.77 1.18 2.881 2.677l.008.215v11.572h11.555c1.596 0 2.89 1.295 2.89 2.893 0 1.525-1.18 2.774-2.674 2.885l-.216.008H158.89v11.571c0 1.598-1.294 2.893-2.889 2.893-1.523 0-2.77-1.18-2.881-2.677l-.008-.216V89.679h-11.555c-1.596 0-2.89-1.296-2.89-2.893 0-1.525 1.18-2.775 2.674-2.885l.216-.008h11.555V72.32c0-1.597 1.294-2.892 2.889-2.892zm69.333 0c1.523 0 2.771 1.18 2.881 2.677l.008.215v11.572h11.556c1.595 0 2.889 1.295 2.889 2.893 0 1.525-1.179 2.774-2.674 2.885l-.215.008h-11.556v11.571c0 1.598-1.293 2.893-2.889 2.893-1.523 0-2.77-1.18-2.88-2.677l-.009-.216V89.679h-11.555c-1.596 0-2.889-1.296-2.889-2.893 0-1.525 1.178-2.775 2.673-2.885l.216-.008h11.555V72.32c0-1.597 1.294-2.892 2.89-2.892zM190.667 0c1.523 0 2.77 1.18 2.88 2.677l.009.216v11.571h11.555c1.596 0 2.889 1.295 2.889 2.893 0 1.525-1.178 2.775-2.673 2.885l-.216.008-11.556-.001v11.572c0 1.598-1.293 2.893-2.888 2.893-1.523 0-2.771-1.18-2.881-2.677l-.008-.216V20.25l-11.556.001c-1.595 0-2.889-1.295-2.889-2.893 0-1.525 1.179-2.774 2.674-2.885l.215-.008h11.555V2.893c0-1.598 1.294-2.893 2.89-2.893zM260 0c1.523 0 2.77 1.18 2.881 2.677l.008.216v11.571h11.555c1.596 0 2.89 1.295 2.89 2.893 0 1.525-1.18 2.775-2.674 2.885l-.216.008-11.555-.001v11.572c0 1.598-1.294 2.893-2.889 2.893-1.523 0-2.77-1.18-2.881-2.677l-.008-.216V20.25l-11.555.001c-1.596 0-2.89-1.295-2.89-2.893 0-1.525 1.18-2.774 2.674-2.885l.216-.008h11.555V2.893C257.111 1.295 258.405 0 260 0z'
      />
    </svg>
  );
}
export function GreenGroupThree({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 133 231' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(33 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(33 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(99 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(99 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(0 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(0 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(66 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(66 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(99)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(99)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(66 197)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(66 197)'
          />
        </g>
      </g>
    </svg>
  );
}
export function GreenGroupFour({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100' height='173' viewBox='0 0 100 173'>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(25 99)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(25 99)'
          />
        </g>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(74 99)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(74 99)'
          />
        </g>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(0 49)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(0 49)'
          />
        </g>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(49 49)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(49 49)'
          />
        </g>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(74)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(74)'
          />
        </g>
        <g>
          <path d='M0 0H50V49H0z' transform='translate(-12 -12) translate(49 148)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M25 12.25c1.098 0 1.998.833 2.078 1.89l.005.152v8.166h8.334c1.15 0 2.083.914 2.083 2.042 0 1.076-.85 1.958-1.928 2.036l-.155.006-8.334-.001v8.167c0 1.128-.932 2.042-2.083 2.042-1.098 0-1.998-.833-2.078-1.89l-.005-.152-.001-8.167h-8.333c-1.15 0-2.083-.913-2.083-2.041 0-1.076.85-1.958 1.928-2.036l.155-.006h8.333v-8.166c0-1.128.933-2.042 2.084-2.042z'
            transform='translate(-12 -12) translate(49 148)'
          />
        </g>
      </g>
    </svg>
  );
}
export function Refund({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H32V32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-.552.448-1 1-1s1 .448 1 1c0 7.18 5.82 13 13 13s13-5.82 13-13S23.18 3 16.006 3c-4.495.028-8.617 2.338-11.004 6.047l5.461-.708c.509-.066.978.263 1.099.749l.022.114c.066.509-.263.978-.749 1.099l-.114.022-7.407.96-.082.008h-.021l.103-.007c-.068.008-.135.01-.2.006l-.015-.001h.014c-.146-.01-.285-.052-.409-.12l.066.033c-.048-.022-.093-.047-.136-.075-.082-.055-.156-.121-.22-.198-.118-.143-.194-.317-.22-.5v-.008l-.962-7.397c-.07-.548.315-1.05.863-1.12.509-.067.978.262 1.099.747l.022.115.583 4.498C6.601 3.404 11.108 1.03 16 1zm0 7c.513 0 .936.386.993.883L17 9v.538c1.09.124 2.154.419 2.857.805.484.266.66.874.394 1.358-.247.45-.789.634-1.252.445l-.106-.05c-.426-.235-1.136-.436-1.892-.542v3.472c2.233.8 3.131 1.55 3.131 3.325 0 1.976-1.216 3.19-3.13 3.54L17 23c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L15 23l.001-1.027c-1.085-.081-2.246-.34-3.341-.737-.52-.187-.788-.76-.6-1.28.187-.52.76-.788 1.28-.6.882.318 1.812.53 2.662.61L15 16.453c-2.34-.849-3.352-1.735-3.352-3.721 0-1.915 1.357-2.97 3.352-3.207V9c0-.552.448-1 1-1zm1 9.17l.001 2.671c.778-.226 1.131-.688 1.131-1.49 0-.495-.263-.808-1.131-1.181zm-3.352-4.438c0 .71.332 1.127 1.352 1.573v-2.763c-.925.152-1.352.542-1.352 1.19z'
        />
      </g>
    </svg>
  );
}

export function Ribbon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='102' viewBox='0 0 48 102' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#0827C7'
          d='M4 0h40c2.21 0 4 1.79 4 4v96.001c0 1.105-.895 2-2 2-.433 0-.853-.14-1.2-.4L23.987 86 3.2 101.598c-.883.663-2.137.485-2.8-.399-.26-.346-.4-.767-.4-1.2V4c0-2.21 1.79-4 4-4z'
        />
        <g>
          <path d='M0 0H24V24H0z' transform='translate(12 40)' />
          <path
            fill='#FFF'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M20 0c.513 0 .936.386.993.883L21 1v15c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L19 16V2H4v18.5c0 .78.595 1.42 1.355 1.493l.094.005.042-.005c.159-.027.38-.088.607-.19l.17-.085C6.75 21.452 7 21.09 7 20.5V19c0-.552.448-1 1-1h15c.552 0 1 .448 1 1v1.5c0 1.933-1.567 3.5-3.5 3.5h-15c-1.869 0-3.395-1.464-3.495-3.308L2 20.5V1c0-.513.386-.936.883-.993L3 0h17zm2 20H9v.5c0 .536-.104 1.015-.295 1.434L8.672 22H20.5c.78 0 1.42-.595 1.493-1.355L22 20.5V20zm-7-7c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 15H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 13h7zm0-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 11H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 9h7zm0-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 7H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 5h7z'
            transform='translate(12 40)'
          />
        </g>
      </g>
    </svg>
  );
}

export function TreeOne({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='42' viewBox='0 0 26 42' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#4ACEA5'
          fillRule='nonzero'
          d='M26 25.262C25.837 32.344 20.065 38 13 38S.163 32.344 0 25.262C0 18.062 13 0 13 0s13 18.062 13 25.262z'
        />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M21.314 12c.674 1.488.25 5.043.25 6.777 0 4.884-2.97 9.275-7.499 11.088-4.529 1.812-9.704.68-13.065-2.859 1.36 6.327 7.27 10.608 13.697 9.922C21.125 36.242 26.001 30.812 26 24.34c.003-4.327-1.682-6.538-4.686-12.34z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M13.5 37L13.5 41' />
      </g>
    </svg>
  );
}

export function TreeTwo({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='51' height='81' viewBox='0 0 51 81' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#4ACEA5'
          fillRule='nonzero'
          d='M51 49.859C50.68 63.837 39.358 75 25.5 75S.32 63.837 0 49.859C0 35.649 25.5 0 25.5 0S51 35.65 51 49.859z'
        />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M41.628 23c1.349 2.917.5 9.883.5 13.284 0 9.571-5.94 18.178-14.997 21.73C18.072 61.568 7.723 59.349 1 52.413c2.721 12.401 14.539 20.79 27.395 19.447C41.251 70.515 51.003 59.87 51 47.186c.007-8.481-3.364-12.814-9.372-24.186z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M26 74L26 81' />
      </g>
    </svg>
  );
}

export function WheelchairTwo({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          d='M5 0c.475 0 .885.334.98.8L6.82 5H17c.552 0 1 .448 1 1s-.448 1-1 1H7.22l.403 2.019C7.749 9.012 7.873 9 8 9c1.829 0 3.585.718 4.889 2H18c1.657 0 3 1.343 3 3v3.141c-.653-.188-1.347-.188-2 0V14c0-.552-.448-1-1-1h-3.685c1.252 2.62.759 5.74-1.24 7.847s-5.09 2.763-7.771 1.65C2.62 21.384.904 18.733.983 15.83c.079-2.902 1.94-5.456 4.679-6.42L4.18 2H2c-.552 0-1-.448-1-1s.448-1 1-1zm15 19c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM8 11c-2.761 0-5 2.239-5 5s2.239 5 5 5c2.76-.003 4.997-2.24 5-5 0-2.761-2.239-5-5-5zm0 3c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z'
        />
      </g>
    </svg>
  );
}

export function WhenToDoCS({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='609' height='627' viewBox='0 0 609 627' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='0%' x2='100%' y1='50%' y2='50%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='4%' stopColor='#FCFDFF' />
          <stop offset='32%' stopColor='#EBEFFD' />
          <stop offset='63%' stopColor='#E0E8FC' />
          <stop offset='100%' stopColor='#DDE5FC' />
        </linearGradient>
        <linearGradient id='prefix__b' x1='0%' x2='100.006%' y1='49.997%' y2='49.997%'>
          <stop offset='0%' stopColor='#DDE5FC' />
          <stop offset='37%' stopColor='#E0E8FC' />
          <stop offset='68%' stopColor='#EBEFFD' />
          <stop offset='96%' stopColor='#FCFDFF' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
        <linearGradient id='prefix__c' x1='0%' x2='100.008%' y1='50.001%' y2='50.001%'>
          <stop offset='0%' stopColor='#F3F6FE' />
          <stop offset='58%' stopColor='#F6F8FE' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M10.091 534.828h6.022c11.32.002 22.44-2.99 32.231-8.671L379.63 333.983c1.218-.707 1.96-2.016 1.942-3.424-.019-1.408-.796-2.696-2.033-3.37l-16.477-8.99v7.727c-.007 2.839-1.525 5.46-3.984 6.879L10.09 534.828z'
          opacity='.3'
          style={{ mixBlendMode: 'multiply' }}
        />
        <path fill='#6A8AEB' fillRule='nonzero' d='M608.801 460.572L366.077 626.676 178.391 536.108 421.121 370.004z' />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M440.045 101.68L177.56 251.972 0.359 145.9 251.403 0.057z'
          opacity='.3'
          transform='translate(162.21 336.828)'
        />
        <path
          fill='url(#prefix__a)'
          fillRule='nonzero'
          d='M594.099 434.684L339.771 582.427 159.29 478.261 413.613 330.512z'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M415.839 386.771L410.927 389.628 373.778 368.189 378.696 365.338zM488.668 466.666L483.757 469.516 371.581 404.773 376.493 401.917zM463.255 402.253L458.349 405.103 384.051 362.221 388.963 359.37zM422.31 440.26L417.398 443.11 361.313 410.736 366.22 407.886z'
        />
        <g fillRule='nonzero'>
          <path
            fill='#BFC9DD'
            d='M85.158.097l21.804 12.585L85.3 25.268 63.495 12.682 85.158.097zm.136 23.771l19.255-11.186L85.197 1.496 65.943 12.682l19.351 11.186'
            transform='translate(264.09 382.345)'
          />
          <path
            fill='#6CEAC0'
            d='M96.137 13.416L96.336 15.061 78.607 15.732 77.565 10.184 80.399 10.014 81.139 13.985z'
            transform='translate(264.09 382.345)'
          />
          <path
            fill='#BFC9DD'
            d='M53.467 18.508L75.27 31.094 53.61 43.674l-21.804-12.58 21.662-12.586zm.136 23.772l19.25-11.186L53.5 19.914 34.246 31.1l19.352 11.186'
            transform='translate(264.09 382.345)'
          />
          <path
            fill='#6CEAC0'
            d='M64.446 31.822L64.645 33.472 46.916 34.144 45.874 28.596 48.709 28.426 49.449 32.391z'
            transform='translate(264.09 382.345)'
          />
          <path
            fill='#BFC9DD'
            d='M22.197 36.687l21.805 12.58-21.663 12.585L.535 49.267l21.662-12.58zm.131 23.771l19.22-11.191-19.35-11.18L2.93 49.272l19.38 11.186'
            transform='translate(264.09 382.345)'
          />
        </g>
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M390.625 458.666L385.708 461.522 329.617 429.148 334.535 426.297zM425.691 503.25L420.779 506.106 308.598 441.358 313.51 438.507zM359.333 476.844L354.421 479.695 298.33 447.326 303.242 444.47zM327.238 495.489L322.332 498.34 266.241 465.966 271.153 463.115z'
        />
        <path fill='#6CEAC0' fillRule='nonzero' d='M262.331 498.363L257.425 501.213 229.377 485.026 234.289 482.176z' />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M393.596 521.895L388.684 524.746 276.509 460.003 281.421 457.152zM456.978 485.072L452.072 487.928 339.89 423.179 344.802 420.329z'
        />
        <path
          fill='#6CEAC0'
          fillRule='nonzero'
          d='M265.16 450.991L265.353 452.635 247.624 453.312 246.588 447.759 249.417 447.588 250.157 451.559z'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M254.175 437.671l21.804 12.586-21.662 12.585-21.804-12.585 21.662-12.586zm.137 23.771l19.254-11.185-19.351-11.186-19.255 11.186 19.352 11.174'
        />
        <path
          fill='#6A8AEB'
          fillRule='nonzero'
          d='M523.302 436.903c3.79 2.19 3.807 5.735.045 7.926-3.762 2.19-9.892 2.19-13.66 0-3.767-2.19-3.807-5.736-.04-7.92 3.768-2.185 9.864-2.19 13.655-.006z'
        />
        <path
          fill='url(#prefix__b)'
          fillRule='nonzero'
          d='M362.372 77.948L5.316 284l.706 247.933c0 2.896 2.06 4.068 4.553 2.611l347.927-200.81c2.521-1.457 4.553-4.985 4.553-7.88l-.683-247.905z'
        />
        <path
          fill='#F0F2F7'
          fillRule='nonzero'
          d='M295.49.569l5.214 3.027c-.831-.484-1.975-.415-3.244.318L292.24.882c1.27-.706 2.42-.774 3.25-.313z'
        />
        <path fill='#BFC9DD' fillRule='nonzero' d='M6.352 533.94L1.138 530.811 0.427 280.967 5.64 283.999z' />
        <path
          fill='#E0E7FC'
          fillRule='nonzero'
          d='M5.64 283.999L.427 280.972.381 263.863 5.595 266.896zM10.148 259.016L4.935 255.983 352.856 55.178 358.075 58.205z'
        />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M5.595 266.89L.38 263.863c0-2.89 2.032-6.423 4.554-7.88l5.213 3.033C7.627 260.472 5.59 264 5.595 266.89z'
        />
        <path
          fill='url(#prefix__c)'
          fillRule='nonzero'
          d='M358.12 58.205c2.522-1.456 4.554-.284 4.554 2.612l.045 17.103L5.692 284l-.052-17.11c0-2.89 2.032-6.418 4.554-7.874L358.12 58.206z'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M39.403 250.663c1.6-.921 2.897-.182 2.903 1.656-.108 2.028-1.181 3.88-2.886 4.984-1.594.922-2.891.182-2.897-1.65.106-2.028 1.177-3.882 2.88-4.99zM28.987 256.677c1.594-.921 2.892-.182 2.897 1.65-.098 2.025-1.16 3.88-2.857 4.99-1.594.922-2.891.182-2.897-1.65.099-2.024 1.16-3.88 2.857-4.99zM18.572 262.686c1.599-.922 2.897-.182 2.902 1.655-.111 2.028-1.183 3.882-2.885 4.99-1.594.916-2.892.177-2.897-1.655.105-2.029 1.176-3.884 2.88-4.99z'
        />
        <path fill='#FFF' fillRule='nonzero' d='M80.991 277.467L81.008 283.146 43.865 304.584 43.848 298.906z' />
        <path
          fill='#6CEAC0'
          fillRule='nonzero'
          d='M287.454 196.35l52.408-30.246c.188 2.765.307 22.832.393 49.25l-52.659 30.394-.142-49.398z'
        />
        <path
          fill='#6A8AEB'
          fillRule='nonzero'
          d='M74.588 417.689l52.408-30.223c.188 2.765.308 22.838.393 49.255l-52.658 30.366-.143-49.398z'
        />
        <ellipse
          cx='80.964'
          cy='423.623'
          fill='#FFF'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 80.964 423.623)'
        />
        <path
          fill='#6A8AEB'
          fillRule='nonzero'
          d='M180.873 207.03l52.408-30.252c.182 2.765.307 22.838.387 49.255l-52.675 30.388-.12-49.392z'
        />
        <ellipse
          cx='187.24'
          cy='212.96'
          fill='#6CEAC0'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 187.24 212.96)'
        />
        <path
          stroke='#FFF'
          strokeLinecap='round'
          strokeWidth='2'
          d='M195.933 223.717L220.976 209.368M195.933 229.515L205.17 224.218'
        />
        <path fill='#FFF' fillRule='nonzero' d='M189.962 224.218L191.807 225.333 189.974 226.391z' />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M189.382 224.354v2.709c0 .188.13.261.29.17l2.277-1.325v6.901c-.01.205-.118.392-.29.501l-5.931 3.414c-.165.097-.296 0-.296-.165v-9.61c.013-.206.123-.394.296-.506l3.654-2.089z'
        />
        <path
          stroke='#FFF'
          strokeLinecap='round'
          strokeWidth='2'
          d='M89.648 434.382L114.691 420.033M89.648 440.18L98.891 434.883'
        />
        <path fill='#FFF' fillRule='nonzero' d='M83.683 434.883L85.522 435.993 83.689 437.057z' />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M83.097 435.02v2.708c0 .188.131.262.296.17l2.277-1.325v6.901c-.007.204-.113.391-.285.501l-5.936 3.414c-.165.097-.296 0-.296-.165v-9.61c.011-.206.121-.395.296-.506l3.648-2.088z'
        />
        <path
          fill='#6CEAC0'
          fillRule='nonzero'
          d='M181.59 306.485l52.408-30.252c.188 2.765.308 22.838.393 49.255l-52.659 30.389-.142-49.392zM74.588 317.864l52.408-30.252c.188 2.765.308 22.838.393 49.255l-52.658 30.389-.143-49.392z'
        />
        <path fill='#FFF' fillRule='nonzero' d='M118.106 244.154L118.123 249.833 43.831 292.71 43.814 287.037z' />
        <path
          fill='#6A8AEB'
          fillRule='nonzero'
          d='M233.924 325.676l52.408-30.246c.188 2.765.313 22.838.393 49.25l-52.658 30.393-.143-49.397z'
        />
        <ellipse
          cx='30.191'
          cy='303.343'
          fill='#6A8AEB'
          fillRule='nonzero'
          rx='11.153'
          ry='6.459'
          transform='rotate(-59.84 30.191 303.343)'
        />
        <path
          stroke='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='3'
          d='M287.425 344.901v-49.5l52.761-30.45.12 40.913c0 4.677-3.29 10.39-7.36 12.74l-45.52 26.297zM287.368 245.281L339.873 214.984 339.873 215.211 340.01 264.603 340.01 264.836 287.425 295.196 287.226 295.31 287.084 245.452zM287.021 345.134L287.067 308.174 287.01 295.43 234.351 325.824 233.947 326.057 181.283 356.451 180.953 356.645 181.294 406.15 287.22 345.015zM287.368 245.048c0-17.16-.057-34.309-.102-49.415l52.63-30.371.137 49.392-52.665 30.394zM234.351 325.59c0-15.128 0-32.277-.045-49.448l52.658-30.394c0 17.16.04 34.331.046 49.448l-52.659 30.395zM332.389 119.66c4.07-2.35 7.399-.456 7.399 4.215l.114 40.92-52.636 30.36c-.086-26.286-.205-46.29-.387-49.255l45.51-26.24zM181.283 356.218c0-15.129 0-32.283-.046-49.449l52.687-30.394c0 17.16.034 34.331.046 49.449l-52.687 30.394zM234.306 275.675c0-17.16-.057-34.308-.103-49.414l52.653-30.395c.046 15.106.08 32.255.103 49.415l-52.653 30.394zM128.231 436.778v-49.466l52.66-30.394v49.466l-52.66 30.394zM233.81 176.544l52.659-30.394c.188 2.765.307 22.838.393 49.256L234.197 225.8c-.08-26.287-.204-46.291-.387-49.256zM181.237 306.303c0-17.16-.057-34.309-.102-49.415l52.664-30.394c.046 15.106.08 32.254.103 49.414l-52.665 30.395zM128.22 386.845c0-15.128 0-32.283-.045-49.448l52.658-30.4c0 17.165.04 34.331.046 49.454l-52.659 30.394zM74.93 417.621L127.731 387.147 127.731 387.613 127.827 421.848 127.867 437.011 75.163 467.428zM180.742 207.172l52.664-30.394c.188 2.765.308 22.838.393 49.25l-52.664 30.4c-.08-26.287-.205-46.292-.393-49.256zM75.02 417.547l-.141-49.398 52.891-30.525c0 17.166.035 34.332.046 49.449l-52.795 30.474zM23.114 488.952l-.12-40.914 51.628-29.791.137 49.391-44.24 25.536c-4.07 2.35-7.394.455-7.405-4.222zM127.936 237.651l52.408-30.246c.182 2.765.307 22.838.387 49.25l-52.67 30.394-.125-49.398zM74.879 367.688l-.137-49.392 52.932-30.547c.045 15.106.08 32.254.102 49.414L74.88 367.688zM22.994 447.571L22.857 398.179 74.48 368.382 74.617 417.78zM22.852 397.713L22.715 348.321 74.338 318.53 74.48 367.922z'
        />
        <ellipse
          cx='81.004'
          cy='322.355'
          fill='#FFF'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 81.004 322.355)'
        />
        <ellipse
          cx='240.308'
          cy='331.609'
          fill='#FFF'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 240.308 331.61)'
        />
        <ellipse
          cx='88.261'
          cy='318.086'
          fill='#6A8AEB'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 88.261 318.086)'
        />
        <ellipse
          cx='295.122'
          cy='200.33'
          fill='#FFF'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 295.122 200.33)'
        />
        <ellipse
          cx='188.254'
          cy='311.57'
          fill='#6A8AEB'
          fillRule='nonzero'
          rx='3.522'
          ry='2.043'
          transform='rotate(-59.84 188.254 311.57)'
        />
        <path
          stroke='#FFF'
          strokeLinecap='round'
          strokeWidth='2'
          d='M248.996 342.369L274.039 328.02M248.996 348.161L258.239 342.87M83.313 335.257L116.41 316.294M83.313 342.762L113.325 325.568M83.313 350.301L100.61 340.389M190.253 322.786L223.355 303.822M190.253 330.29L220.27 313.09M190.253 337.829L207.549 327.918M296.543 213.146L329.64 194.182M296.543 220.651L326.555 203.456M296.543 228.189L313.84 218.284'
        />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M120.041 299.037c.61-.353.655-.273.66.438 0 .341 0 .341.29.222.304-.124.625-.2.951-.228.217-.034.325.171.25.45l-.062.284c-.045.245-.097.478-.16.717-.02.214-.132.41-.307.535-.08.045-.17.069-.261.068-.424.024-.835.153-1.196.376l-.17.102c-.123.075-.235.165-.336.268-.15.156-.25.354-.285.569 0 .182.057.313.182.341.184.057.378.074.57.051h.136c.344-.044.69-.063 1.036-.057.607.049 1.09.53 1.138 1.138.092.787-.066 1.583-.45 2.276-.296.599-.703 1.136-1.2 1.582-.117.078-.184.212-.177.353v.762c-.025.259-.165.492-.381.637l-.381.216-.302.177h-.046c-.216.114-.387 0-.375-.268v-.529c.011-.077.011-.156 0-.233-.067.016-.132.039-.194.068-.377.163-.78.261-1.19.29-.34 0-.403-.113-.307-.569.063-.295.12-.569.188-.881.028-.225.142-.429.319-.57.081-.045.175-.064.267-.056.426-.006.846-.105 1.23-.29.07-.026.136-.058.199-.097.21-.124.402-.277.57-.455.109-.107.196-.235.255-.376.16-.358.097-.694-.136-.74-.143-.046-.294-.063-.444-.05l-.404.04c-.303.046-.61.06-.917.039-.796-.091-1.138-.57-1.138-1.525.089-1.183.628-2.287 1.508-3.084.256-.256.256-.256.256-.569v-.426c-.035-.34.151-.662.461-.803l.353-.193zM224.954 287.897c.61-.348.66-.274.66.443 0 .336 0 .336.297.222.3-.126.62-.203.944-.227.222-.034.325.17.25.45l-.056.278c-.051.245-.103.478-.165.717-.02.216-.132.413-.308.54-.079.046-.17.07-.261.069-.424.023-.835.152-1.196.375-.059.03-.116.064-.17.103-.123.075-.235.165-.336.267-.152.155-.252.354-.285.569 0 .182.057.319.182.347.184.058.379.073.57.046h.136c.343-.047.69-.066 1.036-.057.608.048 1.09.53 1.138 1.138.094.787-.063 1.583-.45 2.275-.294.597-.7 1.132-1.195 1.576-.119.08-.188.216-.182.359v.75c-.024.259-.164.491-.381.632l-.376.222-.307.171-.046.029c-.216.108-.387 0-.37-.274v-.506c.012-.075.012-.152 0-.228-.064.014-.127.035-.187.063-.379.166-.783.267-1.196.296-.341 0-.404-.12-.307-.598l.194-.881c.022-.225.135-.43.313-.57.082-.042.175-.06.267-.05.426-.01.845-.108 1.23-.29.069-.03.135-.063.199-.103.213-.12.405-.274.569-.455.11-.105.196-.231.256-.37.16-.364.103-.694-.137-.746-.143-.046-.294-.063-.443-.05l-.405.045c-.303.045-.61.056-.916.034-.797-.085-1.167-.569-1.138-1.52.087-1.183.627-2.287 1.508-3.083.256-.262.256-.262.256-.569v-.432c-.036-.338.15-.66.461-.797l.347-.21zM331.057 177.62c.609-.347.654-.273.66.443 0 .336 0 .336.29.222.303-.126.624-.203.95-.227.217-.034.325.165.251.45l-.062.278c-.051.245-.103.478-.16.717-.023.216-.136.413-.313.54-.078.043-.166.066-.256.069-.425.022-.838.151-1.2.375l-.166.103c-.122.075-.235.165-.336.267-.152.155-.251.354-.284.569 0 .182.057.319.176.347.185.054.379.07.57.046h.136c.343-.047.69-.066 1.036-.057.609.046 1.092.53 1.138 1.138.096.786-.06 1.583-.444 2.276-.295.597-.702 1.133-1.2 1.576-.117.081-.183.216-.177.358v.649c.006.022.006.046 0 .068-.02.258-.158.491-.376.631l-.381.222-.302.171-.045.028c-.222.109-.387 0-.376-.273v-.506c.009-.076.009-.152 0-.228-.066.014-.131.035-.193.063-.377.167-.78.267-1.19.296-.341 0-.404-.12-.307-.598.057-.29.12-.569.188-.881.027-.225.141-.429.318-.57.08-.043.172-.06.262-.05.428-.01.848-.108 1.235-.29l.2-.103c.211-.122.403-.276.569-.455.106-.108.192-.233.256-.37.159-.364.096-.694-.137-.746-.143-.046-.294-.063-.444-.05l-.404.04c-.305.049-.614.062-.922.039-.791-.085-1.138-.57-1.138-1.52.087-1.183.627-2.287 1.508-3.083.256-.262.256-.262.256-.569v-.427c-.033-.338.152-.66.461-.802l.353-.176z'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M339.15 607.086c-.933.002-1.831-.35-2.515-.984l-95.619-88.44c-1.473-1.393-1.55-3.712-.173-5.2 1.377-1.487 3.696-1.589 5.199-.228l95.618 88.44c1.117 1.033 1.487 2.645.932 4.062-.554 1.416-1.92 2.349-3.442 2.35z'
          opacity='.3'
        />
        <path fill='#FFF' fillRule='nonzero' d='M243.031 342.87L244.875 343.979 243.037 345.038z' />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M242.462 343.007v2.702c0 .188.136.268.296.17l2.276-1.325v6.907c-.013.203-.12.388-.29.501l-5.936 3.414c-.165.097-.296 0-.296-.165l-.029-9.61c.012-.207.122-.395.296-.506l3.683-2.088zM331.085 599.388c-.93.002-1.828-.35-2.51-.984l-95.618-88.44c-.987-.894-1.417-2.248-1.127-3.547.29-1.299 1.255-2.341 2.528-2.73 1.273-.39 2.657-.066 3.624.849l95.62 88.44c1.117 1.034 1.486 2.647.93 4.064-.556 1.417-1.924 2.35-3.447 2.348z'
        />
        <path
          fill='#6CEAC0'
          fillRule='nonzero'
          d='M172.467 576.556L115.608 610.142 56.916 576.265 113.775 542.685zM228.233 471.177c1.2.734 1.11.894-.148 1.576-.598.33-.598.33-.108.734.505.413.945.9 1.303 1.446.273.358 0 .74-.57.876l-.568.16c-.478.147-.94.278-1.418.403-.401.165-.854.153-1.246-.034-.153-.096-.278-.229-.364-.387-.445-.726-1.066-1.328-1.805-1.752l-.341-.2c-.25-.144-.518-.257-.797-.335-.405-.128-.84-.128-1.246 0-.336.153-.501.398-.439.643.078.384.238.746.467 1.064l.16.227c.406.559.767 1.149 1.08 1.764.53 1.081.206 2.213-.87 3.107-1.296.914-2.847 1.398-4.434 1.382-1.335.049-2.668-.156-3.927-.603-.246-.142-.55-.142-.797 0l-.825.45-.398.221-.114.057c-.479.207-1.026.184-1.486-.062l-.74-.455-.569-.37-.09-.051c-.405-.285-.354-.695.119-.922l.888-.484c.14-.067.272-.151.392-.25-.09-.102-.19-.194-.301-.273-.65-.51-1.207-1.125-1.65-1.82-.337-.598-.183-.826.756-1.139.57-.17 1.138-.347 1.708-.506.414-.17.878-.17 1.292 0 .155.1.276.245.347.415.425.748 1.007 1.395 1.707 1.895.117.094.24.18.37.256.417.251.867.443 1.338.569.293.086.6.12.905.097.785-.069 1.314-.49 1.172-.95-.05-.298-.162-.581-.33-.831-.148-.228-.302-.45-.461-.672-.37-.492-.686-1.023-.945-1.581-.603-1.491-.074-2.612 1.617-3.414 1.997-.956 4.314-1.059 6.875-.29.706.21.706.21 1.23-.074l.267-.148.49-.268c.563-.38 1.305-.362 1.85.046l.654.483z'
        />
      </g>
    </svg>
  );
}

export function Engineer({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='676' height='474' viewBox='0 0 676 474' {...props}>
      <defs>
        <linearGradient id='prefix__a' x1='100%' x2='0%' y1='50%' y2='50%'>
          <stop offset='0%' stopColor='#DDE5FC' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
        <linearGradient id='prefix__b' x1='99.997%' x2='-.005%' y1='50.001%' y2='50.001%'>
          <stop offset='0%' stopColor='#DDE5FC' />
          <stop offset='37%' stopColor='#E0E8FC' />
          <stop offset='68%' stopColor='#EBEFFD' />
          <stop offset='96%' stopColor='#FCFDFF' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
        <linearGradient id='prefix__c' x1='0%' x2='100%' y1='50.005%' y2='50.005%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='31%' stopColor='#FFF' stop-opacity='.99' />
          <stop offset='45%' stopColor='#FFF' stop-opacity='.96' />
          <stop offset='55%' stopColor='#FFF' stop-opacity='.91' />
          <stop offset='64%' stopColor='#FFF' stop-opacity='.84' />
          <stop offset='71%' stopColor='#FFF' stop-opacity='.75' />
          <stop offset='78%' stopColor='#FFF' stop-opacity='.64' />
          <stop offset='84%' stopColor='#FFF' stop-opacity='.51' />
          <stop offset='90%' stopColor='#FFF' stop-opacity='.35' />
          <stop offset='95%' stopColor='#FFF' stop-opacity='.18' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
        <linearGradient id='prefix__d' x1='0%' x2='100%' y1='49.997%' y2='49.997%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='31%' stopColor='#FFF' stop-opacity='.99' />
          <stop offset='45%' stopColor='#FFF' stop-opacity='.96' />
          <stop offset='55%' stopColor='#FFF' stop-opacity='.91' />
          <stop offset='64%' stopColor='#FFF' stop-opacity='.84' />
          <stop offset='71%' stopColor='#FFF' stop-opacity='.75' />
          <stop offset='78%' stopColor='#FFF' stop-opacity='.64' />
          <stop offset='84%' stopColor='#FFF' stop-opacity='.51' />
          <stop offset='90%' stopColor='#FFF' stop-opacity='.35' />
          <stop offset='95%' stopColor='#FFF' stop-opacity='.18' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
        <linearGradient id='prefix__e' x1='-2.188%' x2='97.913%' y1='49.368%' y2='49.368%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__f' x1='-.381%' x2='99.708%' y1='301.69%' y2='301.69%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__g' x1='-.224%' x2='99.877%' y1='233.434%' y2='233.434%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__h' x1='-.079%' x2='100.022%' y1='167.11%' y2='167.11%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__i' x1='-.112%' x2='99.989%' y1='183.634%' y2='183.634%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__j' x1='.045%' x2='100.135%' y1='116.229%' y2='116.229%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__k' x1='.202%' x2='100.303%' y1='47.967%' y2='47.967%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__l' x1='.348%' x2='100.449%' y1='-18.354%' y2='-18.354%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__m' x1='.314%' x2='100.415%' y1='-1.827%' y2='-1.827%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__n' x1='.774%' x2='100.875%' y1='-203.81%' y2='-203.81%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__o' x1='101.784%' x2='1.683%' y1='49.153%' y2='49.153%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__p' x1='101.358%' x2='1.257%' y1='49.153%' y2='49.153%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__q' x1='100.931%' x2='.83%' y1='49.155%' y2='49.155%'>
          <stop offset='0%' stopColor='#0C2AAF' />
          <stop offset='100%' stopColor='#0C50F9' />
        </linearGradient>
        <linearGradient id='prefix__r' x1='0%' x2='100%' y1='50.002%' y2='50.002%'>
          <stop offset='0%' stopColor='#DDE5FC' />
          <stop offset='100%' stopColor='#FFF' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#E7EDFD'
          fillRule='nonzero'
          d='M160.848 148.194L228.997 186.546 68.314 280.393.165 242.041 160.848 148.194M515.306 201.39L675.989 295.236 607.85 333.596 447.153 239.749 515.303 201.393M595.598 339.902L286.727 167.33 78.683 286.786l-.366.213 304.61 175.017 212.671-122.114zm-408.146-59.2l106.804-61.375 207.24 118.903-.366.213.242.143-106.595 61.257L187.452 280.7z'
        />
        <path
          fill='url(#prefix__a)'
          fillRule='nonzero'
          d='M303.112 0.07L481.209 105.691 394.066 154.822 215.976 49.2z'
        />
        <path fill='#BFC9DD' fillRule='nonzero' d='M481.209 105.691L481.209 338.809 394.066 387.936 394.066 154.822z' />
        <path fill='#E0E7FC' fillRule='nonzero' d='M215.976 49.2L215.976 282.314 394.066 387.936 394.066 154.822z' />
        <path
          fill='url(#prefix__b)'
          fillRule='nonzero'
          d='M303.009 10.327L463.688 104.174 395.539 142.53 234.86 48.683 303.009 10.327'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M456.419 108.437L302.984 18.806 242.177 52.701 234.849 48.401 302.995 10.254 463.802 104.174z'
          opacity='.5'
        />
        <path
          fill='#A0AEC1'
          fillRule='nonzero'
          d='M394.066 162.696L481.209 113.566 481.209 105.691 394.066 154.822z'
          opacity='.5'
        />
        <path
          fill='#C1C9DB'
          fillRule='nonzero'
          d='M215.976 57.074L394.066 162.696 394.066 154.822 215.976 49.2z'
          opacity='.7'
        />
        <path stroke='#FFF' strokeWidth='3' d='M302.995 10.254L234.849 48.401 395.528 142.534 463.802 104.174z' />
        <path
          fill='#6A8DFA'
          fillRule='nonzero'
          d='M262.497 310.311L290.5 326.58 290.5 258.893 262.497 242.62zM317.742 342.578L345.746 358.851 345.746 291.164 317.742 274.891z'
        />
        <path fill='#3F4FC0' fillRule='nonzero' d='M290.5 326.609L318.504 342.882 318.504 275.195 290.5 258.922z' />
        <path
          fill='url(#prefix__c)'
          fillRule='nonzero'
          d='M290.5 258.922L262.497 276.753 262.497 242.62z'
          opacity='.25'
        />
        <path
          fill='url(#prefix__d)'
          fillRule='nonzero'
          d='M345.746 291.164L345.746 326.58 318.504 342.882 318.504 275.389z'
          opacity='.25'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M254.788 151.5L222.138 132.221 222.252 74.044 254.898 93.337z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__e)'
          fillRule='nonzero'
          d='M254.788 151.5L254.792 148.865 224.417 130.92 224.524 75.396 222.252 74.044 222.138 132.221 254.788 151.5z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M299.114 177.649L266.465 158.37 266.578 100.193 299.228 119.486z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__f)'
          fillRule='nonzero'
          d='M299.114 177.649L299.122 175.013 268.744 157.069 268.854 101.542 266.578 100.193 266.465 158.37 299.114 177.649z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M343.115 204.128L310.465 184.849 310.579 126.675 343.228 145.965z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__g)'
          fillRule='nonzero'
          d='M343.115 204.128L343.119 201.492 312.744 183.551 312.851 128.024 310.579 126.675 310.465 184.849 343.115 204.128z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M387.504 229.855L354.854 210.576 354.968 152.402 387.617 171.692z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__h)'
          fillRule='nonzero'
          d='M387.504 229.855L387.507 227.219 357.133 209.279 357.239 153.748 354.968 152.402 354.854 210.576 387.504 229.855z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M254.788 223.326L222.138 204.047 222.252 145.87 254.898 165.163z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__i)'
          fillRule='nonzero'
          d='M254.788 223.326L254.792 220.69 224.417 202.746 224.524 147.219 222.252 145.87 222.138 204.047 254.788 223.326z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M299.114 249.475L266.465 230.196 266.578 172.018 299.228 191.312z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__j)'
          fillRule='nonzero'
          d='M299.114 249.475L299.122 246.839 268.744 228.895 268.854 173.367 266.578 172.018 266.465 230.196 299.114 249.475z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M343.115 275.954L310.465 256.675 310.579 198.497 343.228 217.791z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__k)'
          fillRule='nonzero'
          d='M343.115 275.954L343.119 273.318 312.744 255.373 312.851 199.846 310.579 198.497 310.465 256.675 343.115 275.954z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M387.504 301.681L354.854 282.402 354.968 224.224 387.617 243.518z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__l)'
          fillRule='nonzero'
          d='M387.504 301.681L387.507 299.045 357.133 281.101 357.239 225.573 354.968 224.224 354.854 282.402 387.504 301.681z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M254.788 295.152L222.138 275.873 222.252 217.695 254.898 236.989z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__m)'
          fillRule='nonzero'
          d='M254.788 295.152L254.792 292.513 224.417 274.572 224.524 219.044 222.252 217.695 222.138 275.873 254.788 295.152z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M387.504 373.507L354.854 354.228 354.968 296.05 387.617 315.344z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__n)'
          fillRule='nonzero'
          d='M387.504 373.507L387.507 370.867 357.133 352.927 357.239 297.399 354.968 296.05 354.854 354.228 387.504 373.507z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M421.256 161.761L453.906 142.471 454.016 200.649 421.37 219.924z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__o)'
          fillRule='nonzero'
          d='M421.37 219.924L454.016 200.649 453.906 142.471 451.63 143.82 451.74 199.348 421.362 217.288 421.37 219.924z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M421.256 233.587L453.906 214.297 454.016 272.471 421.37 291.75z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__p)'
          fillRule='nonzero'
          d='M421.37 291.75L454.016 272.471 453.906 214.297 451.63 215.646 451.74 271.173 421.362 289.114 421.37 291.75z'
          opacity='.5'
        />
        <path
          fill='#0C53FA'
          fillRule='nonzero'
          d='M421.256 305.413L453.906 286.119 454.016 344.297 421.37 363.576z'
          opacity='.6'
        />
        <path
          fill='url(#prefix__q)'
          fillRule='nonzero'
          d='M421.37 363.576L454.016 344.297 453.906 286.119 451.63 287.468 451.74 342.996 421.362 360.94 421.37 363.576z'
          opacity='.5'
        />
        <ellipse cx='272.107' cy='361.692' fill='#BFC9DD' fillRule='nonzero' opacity='.3' rx='16.103' ry='8.179' />
        <path
          fill='#3F4FC0'
          fillRule='nonzero'
          d='M263.035 361.09s-.806 5.866.367 7.541c1.172 1.676 5.195 2.673 4.7.297-.494-2.375-1.666-9.429-1.666-9.429l-3.4 1.591zM274.533 353.253l-.319 3.446c-.033.41.184.8.55.99l2.033 1.033c.27.139.588.147.865.022l.454-.201s4.03 2.84 8.607 1.048c.013-.522-.302-.997-.788-1.188-1.832-.733-6.192-2.632-7.236-4.534-1.337-2.45-4.166-.616-4.166-.616z'
        />
        <path
          fill='#5D76F6'
          fillRule='nonzero'
          d='M279.926 341.54v12.266s-3.854 2.471-7.811 0c0 0 2.077-17.904 1.583-21.958-.495-4.055 8.94-14.004 8.94-14.004s-.348 19.345-2.712 23.696z'
        />
        <path
          fill='#6A8DFA'
          fillRule='nonzero'
          d='M282.63 317.833s.451 5.796-5.976 9.355c0 0-8.698 21.761-8.401 33.133 0 0-3.36 3.666-6.921 0 0 0 .989-23.829 4.942-32.143 0 0-.099-6.925 2.968-9.898 0 .019 7.852 4.212 13.388-.447z'
        />
        <path
          fill='#5D76F6'
          fillRule='nonzero'
          d='M274.833 297.513s1.374-1.543 4.25-.297c3.078 1.334 8.6 4.7 8.6 4.7l.89-3.666s2.276 1.286 4.547.594c0 0 .106 9.139-2.29 9.344-1.7.147-11.402-3.996-14.703-5.58-1.07-.513-1.832-2.437-1.91-3.621-.04-.605.092-1.18.616-1.474z'
        />
        <path
          fill='#3F4FC0'
          fillRule='nonzero'
          d='M267.29 299.177l-.594.462c-3.174 2.462-4.052 6.886-2.06 10.375.71 1.186 1.547 2.293 2.496 3.299 0 0 2.374 2.815 2.15 5.19 0 0 7.86 4.748 13.348-.666 0 0 1.528-15.68-3.418-20.02-1.132-.993-2.243-1.99-3.745-1.866-2.983.25-5.827 1.372-8.178 3.226z'
        />
        <path
          fill='#F4C9C6'
          fillRule='nonzero'
          d='M267.4 290.815s-.22 4.304 2.15 5.5v1.407s2.52 3.563 5.708 1.558c0 0 2.301 0 2.598-1.778.297-1.778 0-4.766 0-4.766l-10.457-1.92z'
        />
        <path
          fill='#3F4FC0'
          fillRule='nonzero'
          d='M269.55 296.307v-2.013s-1.605-1.466-.594-1.833c.436-.186.942-.031 1.199.367.284.378.65.688 1.07.905l.106.055v-2.595l-3.932-.367s-.37 4.22 2.151 5.48z'
        />
        <path
          fill='#E0E7FC'
          fillRule='nonzero'
          d='M265.446 332.727l-5.532-4.153s-2.448-.073-2.004 3.19l6.749 2.672.787-1.709z'
        />
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M267.4 290.815s2.3 2.006 5.264 2.226c2.151 1.483 4.946 1.655 7.262.447.765-.372 1.207-1.19 1.1-2.035-.1-.627-.528-1.305-1.737-1.748 0 0-.224-6.009-6.005-6.16-5.782-.15-5.885 7.27-5.885 7.27z'
        />
        <path
          fill='#F4C9C6'
          fillRule='nonzero'
          d='M262.442 324.065l.817 6.008s-.733 3.633 0 4.377c.733.745 2.37 2.67 4.448 1.335 0 0-2.15-.367-1.63-1.631.52-1.265 2.15-1.038 2.37-.15 0 0 .15-3.263-2.074-3.487l.074-6.863-4.005.411z'
        />
        <path
          fill='#E5B8B7'
          fillRule='nonzero'
          d='M275.258 299.273c-1.241-.044-2.398-.643-3.15-1.632l.582 2.2c.898.17 1.826-.036 2.568-.568z'
        />
        <path
          fill='#5D76F6'
          fillRule='nonzero'
          d='M264.171 303.353s.887-1.929 3.408-1.1c2.52.828 1.78 6.379 1.26 10.011-.52 3.633-2 8.608-1.465 10.386.535 1.778.073 2.599-2.595 2.375-2.667-.223-4.004-2.151-2.744-3.933 1.26-1.782.055-14.99 2.136-17.74z'
        />
        <ellipse
          cx='271.982'
          cy='336.927'
          fill='#CAD3EA'
          fillRule='nonzero'
          rx='2.027'
          ry='1.07'
          transform='rotate(-55.71 271.982 336.927)'
        />
        <path
          fill='#E0E7FC'
          fillRule='nonzero'
          d='M273.126 335.231l-5.588-1.961s-.96-.367-1.465.869c0 0-.312.733.319 1.1l4.448 3.35s-.491-2.855 2.286-3.358z'
        />
        <path fill='#FFF' fillRule='nonzero' d='M299.411 281.632L287.782 288.737 283.667 304.632 295.297 297.528z' />
        <path
          fill='#F4C9C6'
          fillRule='nonzero'
          d='M293.062 298.888s1.868-4.733-.121-4.594c-1.99.14-3.067 4.726-3.33 6.782-.265 2.057 3.385-.938 3.45-2.188z'
        />
        <path
          fill='url(#prefix__r)'
          fillRule='nonzero'
          style={{ mixBlendMode: 'multiply' }}
          d='M394.066 387.936L467.887 387.936 573.776 327.251 481.209 275.587 481.209 338.809z'
        />
        <path
          stroke='#FFF'
          d='M282.846 109.805L282.846 168.012M326.847 136.69L326.847 194.894M371.181 162.586L371.181 220.793M238.465 84.51L238.465 142.717M282.846 181.517L282.846 239.72M326.847 208.032L326.847 266.235M371.181 234.295L371.181 292.502M238.465 155.855L238.465 214.059M371.181 305.607L371.181 363.811M238.465 227.164L238.465 285.371M437.638 152.399L437.638 210.606M437.638 224.111L437.638 282.314M437.638 295.42L437.638 353.627'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M81.736 224.29L81.736 238.47' />
        <ellipse cx='81.736' cy='189.681' fill='#4ACEA5' fillRule='nonzero' rx='35.024' ry='35.042' />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M102.301 161.538c4.572 14.42-.623 30.147-12.882 39.002-12.259 8.855-28.814 8.838-41.055-.041 4.588 14.519 18.02 24.413 33.239 24.484 15.219.07 28.742-9.698 33.465-24.174 4.722-14.475-.437-30.345-12.767-39.271z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M148.746 184.574L148.746 198.757' />
        <ellipse cx='148.746' cy='149.964' fill='#4ACEA5' fillRule='nonzero' rx='35.024' ry='35.042' />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M169.308 121.821c4.578 14.426-.617 30.162-12.883 39.02-12.266 8.859-28.83 8.836-41.073-.055 4.595 14.51 18.025 24.393 33.237 24.462 15.212.069 28.73-9.693 33.456-24.16 4.726-14.468-.42-30.333-12.737-39.267z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M606.901 283.26L606.901 297.44' />
        <ellipse cx='606.901' cy='248.65' fill='#4ACEA5' fillRule='nonzero' rx='35.024' ry='35.042' />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M627.467 220.507c4.578 14.426-.618 30.163-12.885 39.02-12.268 8.858-28.832 8.834-41.074-.059 4.595 14.51 18.023 24.394 33.235 24.464 15.212.07 28.73-9.692 33.457-24.158 4.727-14.467-.418-30.332-12.733-39.267z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M539.895 243.547L539.895 257.727' />
        <ellipse cx='539.895' cy='208.934' fill='#4ACEA5' fillRule='nonzero' rx='35.024' ry='35.042' />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M560.46 180.795c4.579 14.426-.618 30.163-12.885 39.02-12.267 8.857-28.832 8.834-41.073-.06 4.594 14.51 18.023 24.394 33.234 24.464 15.212.07 28.73-9.691 33.458-24.158 4.727-14.466-.418-30.332-12.733-39.266z'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M0.11 30.654L52.402 0.249 69.256 10.07 16.975 40.475z'
          opacity='.5'
          transform='translate(93.797 255.513)'
        />
        <path fill='#BFC9DD' fillRule='nonzero' d='M92.801 255.113L145.093 224.708 148.727 243.353 96.435 273.758z' />
        <path fill='#E0E7FC' fillRule='nonzero' d='M90.342 253.691L142.638 223.286 145.093 224.708 92.801 255.113z' />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M161.049 252.837L163.053 251.627 163.002 265.55 160.994 266.756zM110.736 282.167L112.744 280.972 112.689 294.892 110.681 296.087z'
        />
        <path fill='#E0E7FC' fillRule='nonzero' d='M96.435 273.758L148.727 243.353 163.053 251.627 110.772 282.035z' />
        <path
          fill='#E0E7FC'
          fillRule='nonzero'
          d='M92.801 255.033L96.435 273.677 110.772 281.951 110.717 295.874 108.376 294.529 108.405 283.674 96.032 276.694 95.977 287.362 93.907 286.167 93.962 272.248 90.342 253.61z'
        />
        <path
          fill='#E7EDFD'
          fillRule='nonzero'
          d='M192.933 363.165L257.855 401.085 247.804 406.914 182.883 368.998 192.933 363.165M176.478 373.998L241.4 411.918 231.346 417.747 166.424 379.827 176.478 373.998'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M0.037 32.879L55.978 0.348 74.019 10.858 18.071 43.393z'
          opacity='.5'
          transform='translate(516.984 375.387)'
        />
        <path
          fill='#BFC9DD'
          fillRule='nonzero'
          d='M588.856 372.605L591.004 371.315 590.945 386.22 588.798 387.5zM535.026 403.992L537.162 402.709 537.107 417.604 534.967 418.883z'
        />
        <path fill='#E0E7FC' fillRule='nonzero' d='M517.08 393.684L574.336 361.692 591.004 371.315 535.055 403.846z' />
        <path
          fill='#E0E7FC'
          fillRule='nonzero'
          d='M543.903 387.5L535.055 403.761 535.055 403.761 534.996 418.652 532.505 417.219 532.53 405.602 519.293 398.134 519.227 409.55 517.021 408.267 517.08 393.684 532.783 402.537 541.555 386.422z'
        />
        <path fill='#BFC9DD' fillRule='nonzero' d='M543.903 387.5L597.426 356.992 591.004 371.315 535.026 403.992z' />
        <path
          fill='#E7EDFD'
          fillRule='nonzero'
          d='M475.054 419.213L485.108 425.046 420.186 462.966 410.132 457.137 475.054 419.217M491.512 430.046L501.566 435.878 436.645 473.795 426.591 467.966 491.512 430.046'
        />
      </g>
    </svg>
  );
}

export function Plus1() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 279 179'>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M9.964 159.111c.876 0 1.593.676 1.656 1.534l.005.124v6.63h6.643c.917 0 1.66.741 1.66 1.657 0 .873-.677 1.59-1.536 1.652l-.124.005h-6.643v6.63c0 .915-.744 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.534l-.004-.123-.001-6.63H1.661c-.917 0-1.661-.742-1.661-1.657 0-.874.677-1.59 1.537-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm79.715 0c.875 0 1.592.676 1.656 1.534l.004.124v6.63h6.643c.917 0 1.66.741 1.66 1.657 0 .873-.677 1.59-1.536 1.652l-.124.005H91.34v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.534l-.004-.123v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.662-1.657zm39.857 0c.875 0 1.592.676 1.656 1.534l.004.124v6.63h6.643c.917 0 1.661.741 1.661 1.657 0 .873-.677 1.59-1.537 1.652l-.124.005h-6.643v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.656-1.534l-.005-.123v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.642l.001-6.63c0-.915.744-1.657 1.66-1.657zm39.857 0c.875 0 1.593.676 1.656 1.534l.005.124v6.63h6.642c.918 0 1.661.741 1.661 1.657 0 .873-.677 1.59-1.537 1.652l-.124.005h-6.642v6.63c0 .915-.744 1.657-1.661 1.657-.876 0-1.593-.676-1.656-1.534l-.005-.123v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.643v-6.63c0-.915.744-1.657 1.66-1.657zM69.75 119.333c.875 0 1.593.676 1.656 1.534l.005.124-.001 6.63h6.644c.917 0 1.66.741 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004H71.41v6.63c0 .915-.743 1.657-1.66 1.657-.875 0-1.593-.676-1.656-1.533l-.005-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.643v-6.63c0-.915.744-1.657 1.661-1.657zm159.429 0c.875 0 1.592.676 1.656 1.534l.004.124v6.63h6.643c.917 0 1.66.741 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.643v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.662-1.657zm-39.858 0c.876 0 1.593.676 1.657 1.534l.004.124v6.63h6.643c.917 0 1.66.741 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.644l.001 6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm-79.714 0c.876 0 1.593.676 1.656 1.534l.005.124v6.63h6.643c.917 0 1.66.741 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.643v6.63c0 .915-.744 1.657-1.66 1.657-.876 0-1.594-.676-1.657-1.533l-.005-.124v-6.63h-6.642c-.918 0-1.661-.742-1.661-1.657 0-.874.677-1.59 1.537-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm39.857 0c.876 0 1.593.676 1.656 1.534l.005.124-.001 6.63h6.644c.917 0 1.66.741 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.644l.001 6.63c0 .915-.744 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124-.001-6.63h-6.642c-.917 0-1.661-.742-1.661-1.657 0-.874.677-1.59 1.537-1.653l.124-.005h6.642v-6.63c0-.915.744-1.657 1.661-1.657zM9.964 79.556c.876 0 1.593.676 1.656 1.533l.005.124v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.643v6.63c0 .915-.744 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124-.001-6.63H1.661C.744 91.157 0 90.415 0 89.5c0-.874.677-1.59 1.537-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm159.429 0c.875 0 1.593.676 1.656 1.533l.005.124v6.63h6.642c.918 0 1.661.742 1.661 1.657 0 .874-.677 1.59-1.537 1.653l-.124.004h-6.642v6.63c0 .915-.744 1.657-1.661 1.657-.876 0-1.593-.676-1.656-1.533l-.005-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.004h6.643v-6.63c0-.915.744-1.657 1.66-1.657zm-79.714 0c.875 0 1.592.676 1.656 1.533l.004.124v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004H91.34v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.662-1.657zm39.857 0c.875 0 1.592.676 1.656 1.533l.004.124v6.63h6.643c.917 0 1.661.742 1.661 1.657 0 .874-.677 1.59-1.537 1.653l-.124.004h-6.643v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.656-1.533l-.005-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.004h6.642l.001-6.63c0-.915.744-1.657 1.66-1.657zm-79.715 0c.876 0 1.593.676 1.657 1.533l.004.124v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.004h-6.643v6.63c0 .915-.743 1.657-1.66 1.657-.876 0-1.593-.676-1.657-1.533l-.004-.124v-6.63h-6.643c-.917 0-1.66-.742-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm59.786-39.778c.876 0 1.593.676 1.656 1.533l.005.124v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.005-6.643-.001v6.63c0 .916-.744 1.658-1.66 1.658-.876 0-1.594-.676-1.657-1.534l-.005-.124v-6.63h-6.642c-.918 0-1.661-.741-1.661-1.657 0-.874.677-1.59 1.537-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm39.857 0c.876 0 1.593.676 1.656 1.533l.005.124-.001 6.63h6.644c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.005-6.644-.001.001 6.63c0 .916-.744 1.658-1.66 1.658-.876 0-1.593-.676-1.657-1.534l-.004-.124-.001-6.63h-6.642c-.917 0-1.661-.741-1.661-1.657 0-.874.677-1.59 1.537-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm39.857 0c.876 0 1.593.676 1.657 1.533l.004.124v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.005-6.644-.001.001 6.63c0 .916-.743 1.658-1.66 1.658-.876 0-1.593-.676-1.657-1.534l-.004-.124v-6.63h-6.643c-.917 0-1.66-.741-1.66-1.657 0-.874.677-1.59 1.536-1.653l.124-.004h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm0-39.778c.876 0 1.593.676 1.657 1.534l.004.123v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.005-6.644-.001.001 6.63c0 .916-.743 1.658-1.66 1.658-.876 0-1.593-.676-1.657-1.534l-.004-.124v-6.63h-6.643c-.917 0-1.66-.741-1.66-1.657 0-.873.677-1.59 1.536-1.652l.124-.005h6.642v-6.63c0-.915.744-1.657 1.661-1.657zm39.858 0c.875 0 1.592.676 1.656 1.534l.004.123v6.63h6.643c.917 0 1.66.742 1.66 1.657 0 .874-.677 1.59-1.536 1.653l-.124.005-6.643-.001v6.63c0 .916-.743 1.658-1.66 1.658-.876 0-1.593-.676-1.657-1.534l-.004-.124v-6.63h-6.643c-.917 0-1.66-.741-1.66-1.657 0-.873.677-1.59 1.536-1.652l.124-.005h6.642v-6.63c0-.915.744-1.657 1.662-1.657zm39.857 0c.875 0 1.592.676 1.656 1.534l.004.123v6.63h6.643c.917 0 1.661.742 1.661 1.657 0 .874-.677 1.59-1.537 1.653l-.124.005-6.644-.001.001 6.63c0 .916-.743 1.658-1.66 1.658-.876 0-1.593-.676-1.656-1.534l-.005-.124v-6.63h-6.643c-.917 0-1.66-.741-1.66-1.657 0-.873.677-1.59 1.536-1.652l.124-.005h6.642l.001-6.63c0-.915.744-1.657 1.66-1.657z'
      />
    </svg>
  );
}

export function Plus2() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 242 188'>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M13.444 161.143c1.182 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.238 0 2.24 1.002 2.24 2.238 0 1.18-.913 2.147-2.073 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167-.001-8.953H2.241c-1.238 0-2.241-1.002-2.241-2.238 0-1.18.914-2.146 2.074-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.241-2.238zm107.556 0c1.181 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.241 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.963v-8.952c0-1.236 1.003-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.07l.007.168v8.952h8.962c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.073 2.232l-.168.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.778 0c1.18 0 2.149.913 2.234 2.07l.006.168v8.952h8.963c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.074 2.232l-.167.007-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.238 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.242-2.238zM94.11 107.429c1.181 0 2.15.913 2.235 2.07l.006.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.006h-8.963v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.007-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.963v-8.952c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.07l.007.168v8.952h8.963c1.237 0 2.24 1.002 2.24 2.238 0 1.18-.914 2.147-2.073 2.232l-.167.006h-8.964v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.146 2.073-2.232l.167-.006h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.778 0c1.18 0 2.149.913 2.234 2.07l.006.168v8.952h8.963c1.238 0 2.241 1.002 2.241 2.238 0 1.18-.914 2.147-2.073 2.232l-.168.006h-8.963v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.071l-.006-.167v-8.953h-8.963c-1.238 0-2.24-1.002-2.24-2.238 0-1.18.913-2.146 2.073-2.232l.167-.006h8.962v-8.952c0-1.236 1.004-2.238 2.242-2.238zM13.444 53.714c1.182 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.238 0 2.24 1.003 2.24 2.239 0 1.18-.913 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.006-.168-.001-8.953-8.962.001C1.003 69.381 0 68.379 0 67.143c0-1.18.914-2.147 2.074-2.232l.167-.006h8.962v-8.953c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.913 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.007-.168V69.38l-8.962.001c-1.238 0-2.241-1.002-2.241-2.238 0-1.18.914-2.147 2.073-2.232l.168-.006h8.962v-8.953c0-1.236 1.004-2.238 2.241-2.238zm53.778 0c1.181 0 2.15.913 2.235 2.071l.006.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.914 2.146-2.073 2.232l-.167.006h-8.963v8.952c0 1.236-1.003 2.238-2.241 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168V69.38l-8.963.001c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.914-2.147 2.073-2.232l.167-.006h8.963v-8.953c0-1.236 1.003-2.238 2.241-2.238zm53.778 0c1.181 0 2.149.913 2.234 2.071l.007.167v8.952h8.962c1.238 0 2.241 1.003 2.241 2.239 0 1.18-.914 2.146-2.073 2.232l-.168.006h-8.963v8.952c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168V69.38l-8.963.001c-1.237 0-2.24-1.002-2.24-2.238 0-1.18.913-2.147 2.073-2.232l.167-.006h8.962l.001-8.953c0-1.236 1.003-2.238 2.24-2.238zM147.888 0c1.182 0 2.15.913 2.235 2.071l.007.167v8.952h8.963c1.237 0 2.24 1.003 2.24 2.239 0 1.18-.914 2.146-2.073 2.232l-.167.006-8.964-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.181 0-2.15-.913-2.235-2.07l-.006-.168v-8.953h-8.963c-1.237 0-2.24-1.001-2.24-2.237 0-1.18.914-2.147 2.073-2.232l.167-.007h8.962l.001-8.952c0-1.236 1.003-2.238 2.24-2.238zm53.779 0c1.18 0 2.149.913 2.234 2.071l.006.167v8.952h8.963c1.238 0 2.241 1.003 2.241 2.239 0 1.18-.914 2.146-2.073 2.232l-.168.006-8.963-.001v8.953c0 1.236-1.003 2.238-2.24 2.238-1.182 0-2.15-.913-2.235-2.07l-.006-.168v-8.953h-8.963c-1.238 0-2.24-1.001-2.24-2.237 0-1.18.913-2.147 2.073-2.232l.167-.007h8.962V2.238c0-1.236 1.004-2.238 2.242-2.238z'
      />
    </svg>
  );
}

export function Plus3() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='632' height='406' viewBox='0 0 632 406'>
      <defs>
        <linearGradient id='prefix__a' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#F2F2F2' />
        </linearGradient>
      </defs>
      <path
        fill='url(#prefix__a)'
        fillRule='evenodd'
        d='M383.714 360.889c1.983 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.534-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm-90.285 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.28.01H297.19v15.038c0 2.076-1.684 3.759-3.761 3.759-1.984 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm-270.858 0c1.984 0 3.608 1.533 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01H26.333v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038H3.762c-2.078 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.481-3.749l.28-.01H18.81v-15.037c0-2.076 1.685-3.76 3.762-3.76zm180.572 0c1.983 0 3.608 1.533 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.748l-.282.01h-15.048v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28v-15.038h-15.048c-2.077 0-3.762-1.682-3.762-3.759 0-1.981 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zM158 270.667c1.983 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.077 0 3.761 1.683 3.761 3.76 0 1.981-1.534 3.605-3.48 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98H139.19c-2.077 0-3.761-1.683-3.761-3.759 0-1.982 1.534-3.605 3.48-3.749l.281-.01h15.048v-15.037c0-2.076 1.684-3.76 3.762-3.76zm90.286 0c1.983 0 3.608 1.533 3.751 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.481 3.748l-.28.01h-15.049v15.038c0 2.076-1.684 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98h-15.048c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm270.857 0c1.983 0 3.608 1.533 3.751 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.748l-.282.01h-15.048v15.038c0 2.076-1.683 3.759-3.761 3.759-1.983 0-3.608-1.534-3.752-3.479l-.01-.28V296.98h-15.048c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm-90.286 0c1.983 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.482 3.748l-.28.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.48-3.749l.282-.01h15.047v-15.037c0-2.076 1.684-3.76 3.762-3.76zm-90.286 0c1.984 0 3.608 1.533 3.752 3.478l.01.28v15.038h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.748l-.281.01h-15.048v15.038c0 2.076-1.684 3.759-3.762 3.759-1.983 0-3.608-1.534-3.751-3.479l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm45.143-90.223c1.983 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.481-3.749l.28-.01h15.048v-15.037c0-2.076 1.685-3.76 3.762-3.76zm-270.857 0c1.983 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.482 3.749l-.28.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.534-3.605 3.48-3.749l.282-.01h15.047v-15.037c0-2.076 1.684-3.76 3.762-3.76zm180.572 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.28.01H297.19v15.037c0 2.076-1.684 3.76-3.761 3.76-1.984 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.078 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.481-3.749l.281-.01h15.047v-15.037c0-2.076 1.685-3.76 3.763-3.76zm-90.286 0c1.983 0 3.608 1.534 3.751 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.48 3.749l-.282.01h-15.048v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.077 0-3.762-1.683-3.762-3.759 0-1.982 1.535-3.605 3.482-3.749l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.76 3.762-3.76zm-180.572 0c1.984 0 3.608 1.534 3.752 3.48l.01.28v15.036h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01H26.333v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001C1.684 206.76 0 205.076 0 203c0-1.982 1.535-3.605 3.481-3.749l.28-.01H18.81v-15.037c0-2.076 1.685-3.76 3.762-3.76zm225.715-90.222c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.534 3.605-3.481 3.749l-.28.01h-15.049v15.037c0 2.076-1.684 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28v-15.038l-15.048.001c-2.077 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.281-.01h15.047V93.98c0-2.076 1.685-3.759 3.763-3.759zm90.285 0c1.984 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.481 3.749l-.281.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.76 0-1.981 1.535-3.605 3.481-3.748l.28-.01h15.048V93.98c0-2.076 1.685-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.684 3.762 3.76 0 1.982-1.535 3.605-3.482 3.749l-.28.01h-15.048v15.037c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038-15.047.001c-2.078 0-3.762-1.683-3.762-3.76 0-1.981 1.534-3.605 3.48-3.748l.282-.01h15.047V93.98c0-2.076 1.684-3.759 3.762-3.759zm0-90.222c1.983 0 3.608 1.534 3.752 3.479l.01.28v15.037h15.048c2.077 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.482 3.749l-.28.01-15.048-.001v15.038c0 2.076-1.684 3.76-3.762 3.76-1.983 0-3.608-1.534-3.751-3.48l-.01-.28-.001-15.038h-15.047c-2.078 0-3.762-1.682-3.762-3.758 0-1.982 1.534-3.606 3.48-3.75l.282-.01h15.047V3.759c0-2.076 1.684-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.534 3.605-3.48 3.749l-.282.01-15.048-.001v15.038c0 2.076-1.683 3.76-3.761 3.76-1.983 0-3.608-1.534-3.752-3.48l-.01-.28V26.314h-15.048c-2.077 0-3.762-1.682-3.762-3.758 0-1.982 1.535-3.606 3.482-3.75l.28-.01h15.047l.001-15.037c0-2.076 1.684-3.759 3.762-3.759zm90.286 0c1.983 0 3.608 1.534 3.751 3.479l.01.28v15.037h15.048c2.078 0 3.762 1.683 3.762 3.76 0 1.981-1.535 3.605-3.481 3.749l-.28.01-15.049-.001v15.038c0 2.076-1.684 3.76-3.761 3.76-1.984 0-3.608-1.534-3.752-3.48l-.01-.28V26.314h-15.048c-2.078 0-3.762-1.682-3.762-3.758 0-1.982 1.535-3.606 3.481-3.75l.281-.01h15.047V3.759c0-2.076 1.685-3.759 3.763-3.759z'
      />
    </svg>
  );
}
export function Plus4({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='67' height='166' viewBox='0 0 67 166' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(33 132)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(33 132)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(0 65)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(0 65)'
          />
        </g>
        <g>
          <path d='M0 0H66V66H0z' transform='translate(-16 -16) translate(33)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M33 16.5c1.45 0 2.637 1.122 2.742 2.545l.008.205v11h11c1.519 0 2.75 1.231 2.75 2.75 0 1.45-1.122 2.637-2.545 2.742l-.205.008h-11v11c0 1.519-1.231 2.75-2.75 2.75-1.45 0-2.637-1.122-2.742-2.545l-.008-.205v-11h-11c-1.519 0-2.75-1.231-2.75-2.75 0-1.45 1.122-2.637 2.545-2.742l.205-.008h11v-11c0-1.519 1.231-2.75 2.75-2.75z'
            transform='translate(-16 -16) translate(33)'
          />
        </g>
      </g>
    </svg>
  );
}

export function PlusGreen({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='56' height='97' viewBox='0 0 56 97' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(14 56)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(14 56)'
          />
        </g>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(42 56)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(42 56)'
          />
        </g>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(0 27)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(0 27)'
          />
        </g>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(28 27)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(28 27)'
          />
        </g>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(42)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(42)'
          />
        </g>
        <g>
          <path d='M0 0H28V28H0z' transform='rotate(-180 31.5 52) translate(28 83)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14 7c.615 0 1.119.476 1.163 1.08l.004.087-.001 4.666h4.667c.645 0 1.167.523 1.167 1.167 0 .615-.476 1.119-1.08 1.163l-.087.004-4.667-.001v4.667c0 .645-.522 1.167-1.166 1.167-.615 0-1.119-.476-1.163-1.08l-.004-.087v-4.667H8.167C7.522 15.167 7 14.645 7 14c0-.615.476-1.119 1.08-1.163l.087-.004h4.666V8.167C12.833 7.522 13.356 7 14 7z'
            transform='rotate(-180 31.5 52) translate(28 83)'
          />
        </g>
      </g>
    </svg>
  );
}

export function TreeLg({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='23' height='37' viewBox='0 0 23 37' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#4ACEA5'
          fillRule='nonzero'
          d='M23 22.775c-.144 6.385-5.25 11.484-11.5 11.484S.144 29.16 0 22.775C0 16.285 11.5 0 11.5 0S23 16.284 23 22.775z'
        />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M18.774 10.506c.608 1.333.225 4.515.225 6.068 0 4.372-2.679 8.304-6.764 9.927-4.085 1.622-8.752.608-11.784-2.56 1.227 5.665 6.557 9.497 12.355 8.883C18.603 32.211 23 27.35 23 21.554c.003-3.874-1.517-5.853-4.226-11.048z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M11.725 33.802L11.725 37' />
      </g>
    </svg>
  );
}

export function TreeSm({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='23' viewBox='0 0 14 23' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#4ACEA5'
          fillRule='nonzero'
          d='M14 14.157c-.088 3.97-3.196 7.14-7 7.14s-6.912-3.17-7-7.14C0 10.123 7 0 7 0s7 10.123 7 14.157z'
        />
        <path
          fill='#38AF87'
          fillRule='nonzero'
          d='M11.427 6.53c.37.83.137 2.807.137 3.773 0 2.718-1.63 5.162-4.116 6.17-2.487 1.009-5.328.379-7.173-1.59.746 3.52 3.99 5.903 7.52 5.521C11.324 20.023 14 17.001 14 13.398c.002-2.408-.924-3.638-2.573-6.867z'
        />
        <path stroke='#38AF87' strokeLinecap='round' strokeWidth='2' d='M7.137 21.012L7.137 23' />
      </g>
    </svg>
  );
}

export function Shop({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M4 23c-.513 0-.936-.386-.993-.883L3 22v-9c0-.552.448-1 1-1 .513 0 .936.386.993.883L5 13v8h4v-5c0-.513.386-.936.883-.993L10 15h4c.513 0 .936.386.993.883L15 16v5h4v-8c0-.513.386-.936.883-.993L20 12c.513 0 .936.386.993.883L21 13v9c0 .513-.386.936-.883.993L20 23H4zm9-6h-2v4h2v-4zm7-16c.351 0 .677.184.857.486l3 5c.093.154.143.331.143.512.004 1.852-1.267 3.464-3.069 3.892-1.268.302-2.565-.038-3.511-.844l-.085-.075-.15.13c-.645.527-1.448.847-2.304.893l-.215.006c-.935 0-1.82-.328-2.518-.898L12 9.973l-.148.129c-.645.526-1.448.846-2.304.892L9.334 11c-.936 0-1.82-.328-2.519-.898l-.151-.131-.084.075c-.896.763-2.107 1.109-3.31.887l-.201-.043C1.267 10.462-.004 8.85 0 6.998c0-.18.05-.358.142-.512l3-5C3.323 1.184 3.65 1 4 1zm-.566 2H4.565L2.016 7.249l.01.074c.116.732.636 1.346 1.35 1.578l.155.044c.9.213 1.828-.22 2.242-1.046l.064-.11c.414-.625 1.378-.587 1.726.113l.077.14c.355.591.996.958 1.694.958.75 0 1.436-.425 1.77-1.098l.064-.11c.413-.628 1.38-.591 1.728.11l.077.14c.355.591.996.958 1.693.958.751 0 1.437-.425 1.771-1.098l.064-.11c.412-.627 1.376-.592 1.726.107l.078.142c.445.733 1.317 1.105 2.164.904.793-.189 1.38-.837 1.506-1.622l.008-.074L19.434 3z'
        />
      </g>
    </svg>
  );
}
